// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27white%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

html,
body,
* {
  font-family: "Inter", sans-serif;
}

html,
body {
  background-color: #ffffff !important;
}

body {
  overflow-x: hidden;
}

@media only screen and (max-width: 991.98px) {
  html {
    overflow-x: hidden;
  }
}

.btn-outline-primary {
  background: #ffffff !important;
  border: 1px solid #3c5b8a !important;
  color: #3c5b8a !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
}
.btn-outline-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-outline-primary {
    font-size: 14px !important;
  }
}
.btn-outline-primary:hover {
  opacity: 0.75;
  color: #3c5b8a !important;
}

.btn-primary {
  background: #3c5b8a !important;
  border-color: #3c5b8a !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: #ffffff !important;
}
.btn-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-primary {
    font-size: 14px !important;
  }
  .btn-primary svg {
    font-size: 16px;
  }
}
.btn-primary:hover {
  opacity: 0.75;
  color: #ffffff !important;
}

.btn-lt-primary {
  background: rgba(60, 91, 138, 0.13) !important;
  border-color: rgba(60, 91, 138, 0.13) !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: #3c5b8a !important;
}
.btn-lt-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-lt-primary {
    font-size: 14px !important;
  }
  .btn-lt-primary svg {
    font-size: 16px;
  }
}
.btn-lt-primary:hover {
  opacity: 0.75;
  color: #3c5b8a !important;
}

/*Loader Css Start*/
.loaderdiv {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 111;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loaderdiv img {
  height: 100px;
  animation: zoom 3s infinite;
}
@keyframes zoom {
  0%, 100% {
    transform: scale(1);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/*Loader Css Ends*/
/*Auth Css Start*/
.login-main {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 120px;
}
.login-main.signup-main {
  padding-top: 90px;
  padding-bottom: 90px;
}
.login-main .loginbg {
  height: 452px;
  width: 100%;
  position: absolute;
  z-index: -1;
  top: 0px;
  background: #000000;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 0% 100%);
}
.login-main .loginbg img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  opacity: 0.41;
}
.login-main .loginform {
  background: #ffffff;
  padding: 70px;
  border-radius: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
}
@media only screen and (max-width: 991.98px) {
  .login-main .loginform {
    padding: 30px;
  }
}
@media only screen and (max-width: 767.98px) {
  .login-main .loginform {
    padding: 20px;
  }
  .login-main .loginform .btn-primary {
    font-size: 16px !important;
  }
}
.login-main .loginform .headlogin_div h2 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
.login-main .loginform .headlogin_div p {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.5;
  max-width: 320px;
  margin: 0 auto;
}
.login-main .loginform .forgotpassword a {
  color: #000000;
  font-weight: 600;
  text-decoration: none;
  font-size: 16px;
}
.login-main .loginform .formfooter {
  font-size: 16px;
  color: #000000;
}
.login-main .loginform .formfooter a {
  color: #3c5b8a;
  font-weight: 700;
  text-decoration: none;
}
.login-main .loginform .form-group .form-label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
.login-main .loginform .form-group .form-label span {
  opacity: 0.3;
}
.login-main .loginform .form-group .password-input-group svg {
  position: absolute;
  top: 17px;
  right: 20px;
  opacity: 0.8;
}
.login-main .loginform .form-group .otpinput {
  flex: 1 1;
  height: 65px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  color: rgba(0, 0, 0, 0.7);
  box-shadow: none;
  outline: none;
}
.login-main .loginform .form-group .otpinput:focus {
  border: 2px solid #3c5b8a !important;
}
@media only screen and (max-width: 500px) {
  .login-main .loginform .form-group .otpinput {
    flex: 1 1;
    height: 55px;
  }
}
.login-main .loginform .form-group .form-control {
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.7);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
}
.login-main .loginform .form-group .form-control[type=password] {
  padding-right: 50px;
}
.login-main .loginform .form-group .form-control:focus {
  box-shadow: none;
}
.login-main .loginform .form-group .form-control::placeholder {
  color: #000000;
  opacity: 0.5;
}

.modal-custom.datamodal .modal-content .modal-header .modal-title {
  font-size: 22px !important;
  font-weight: 400 !important;
}
.modal-custom.datamodal .modal-content .modal-header .modal-title b {
  font-weight: 600;
}
.modal-custom.datamodal .modal-content .modal-body h6 {
  font-weight: 600;
}
.modal-custom.datamodal .modal-content .modal-body p {
  margin-bottom: 2px;
}
.modal-custom .modal-dialog .modal-content .modal-header .modal-title {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}
.modal-custom .modal-dialog .modal-content .btn-close {
  width: 28px;
  height: 28px;
  background-color: #3c5b8a;
  border-radius: 50%;
  padding: 0 !important;
  background-size: 10px;
  background-position: center;
  opacity: 1;
  position: absolute;
  top: -7px;
  right: -7px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain {
  max-height: 370px;
  overflow-y: auto;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain::-webkit-scrollbar {
  width: 6px;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain::-webkit-scrollbar-thumb {
  background: #ccc;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain .notescont {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.07);
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  font-size: 13px;
  padding: 16px;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain .notescont:not(:last-child) {
  margin-bottom: 14px;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain .notescont h4 {
  color: #000000;
  font-size: 14px;
}
.modal-custom .modal-dialog .modal-content .modal-body .notesmain .notescont a {
  color: #000000;
  font-size: 14px;
  min-width: 23px;
  text-align: end;
}
.modal-custom .modal-dialog .modal-content .modal-body .form-control, .modal-custom .modal-dialog .modal-content .modal-body .form-select {
  height: auto;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #000000;
  padding-left: 20px;
  min-height: 38px;
  padding-right: 20px;
  font-size: 14px;
  resize: none;
}
.modal-custom .modal-dialog .modal-content .modal-body .form-control:focus, .modal-custom .modal-dialog .modal-content .modal-body .form-select:focus {
  box-shadow: none;
}
.modal-custom .modal-dialog .modal-content .modal-body .form-control::placeholder, .modal-custom .modal-dialog .modal-content .modal-body .form-select::placeholder {
  color: #000000;
  opacity: 0.5;
}

.reset-success .modal-dialog {
  max-width: 437px;
}
.reset-success .modal-dialog .modal-content {
  border-radius: 30px;
}
.reset-success .modal-dialog .modal-content .modal-body {
  text-align: center;
  padding: 40px;
}
.reset-success .modal-dialog .modal-content .modal-body h2 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
.reset-success .modal-dialog .modal-content .modal-body p {
  font-size: 16px;
  color: #6C6A72;
  font-weight: 400;
  line-height: 1.5;
}
.reset-success .modal-dialog .modal-content .modal-body .btn {
  min-width: 170px;
}

/*Auth Css Ends*/
/*Sidebar Css Start*/
.sidebar {
  background: #ffffff;
  height: 100%;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  position: fixed;
  scrollbar-color: #e3e3e3 transparent;
  scrollbar-width: thin;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  top: 0;
  width: 270px;
  z-index: 1031;
}
.sidebar .sidebarlogo_div {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.sidebar .sidebarlogo_div img {
  height: 70px;
}
@media only screen and (max-width: 767.98px) {
  .sidebar.sidebar-open {
    left: 0;
    transition: all 1s ease-in-out;
  }
  .sidebar.sidebar-closed {
    left: -320px;
    transition: all 1s ease-in-out;
  }
}

@media only screen and (max-width: 767.98px) {
  button.btnclose {
    background: rgba(0, 0, 0, 0.5);
    bottom: 0;
    left: 0;
    padding: 0;
    position: fixed;
    top: 0;
    transition: all 1s ease-in-out;
  }
  button.btnclose.sidebarbg-open {
    transition: all 1s ease-in-out;
    width: 100%;
  }
}
.sidebarouter .submenu .navitem.submenu-item::before {
  display: none;
}
.sidebarouter .navitem {
  padding: 12px 20px;
  position: relative;
  color: #000000;
  font-size: 14px;
  text-decoration: none;
  margin-bottom: 10px;
  display: flex;
  font-weight: 500;
}
.sidebarouter .navitem svg {
  font-size: 20px;
  margin-right: 10px;
  min-width: 20px;
}
.sidebarouter .navitem:before {
  content: "";
  position: absolute;
  top: 0px;
  left: -20px;
  height: 100%;
  background: #3c5b8a;
  width: 0;
  border-radius: 0px 14px 14px 0px;
}
.sidebarouter .navitem.active, .sidebarouter .navitem:hover {
  color: #ffffff;
  background: #3c5b8a;
  display: flex;
  border-radius: 6px;
}
.sidebarouter .navitem.active:before, .sidebarouter .navitem:hover:before {
  width: 4px;
}

.inactive.active {
  color: #000000;
  background-color: #3c5b8a;
}

.badgestatus-more {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
}

@media only screen and (max-width: 767.98px) {
  .header,
  .maincontent_div {
    margin-left: 0 !important;
  }
  button.btnclose,
  button.btnopen {
    border: 0 !important;
    display: block !important;
    outline: 0 !important;
    z-index: 101;
  }
  button.btnopen {
    background: transparent !important;
    box-shadow: none !important;
    left: 15px;
    position: absolute;
    top: 20px;
  }
  button.btnopen svg {
    font-size: 34px;
  }
}
/*Sidebar Css Ends*/
/*Header Css Start*/
.header {
  margin-left: 270px;
  position: relative;
  z-index: 1;
  padding: 10px 15px;
}
.header .form-switch {
  position: relative;
}
.header .form-switch .form-check-input {
  width: 49px;
  height: 25px;
  border: 1px solid #000000;
  --bs-form-check-bg: #000;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.header .form-switch .form-check-input:checked {
  background-color: #000000;
}
.header .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border: none;
  outline: 0;
  box-shadow: none;
}
.header .form-switch svg {
  position: absolute;
  top: 8px;
  font-size: 18px;
  color: #ffffff;
}
.header .form-switch svg.light-icon {
  right: 5px;
}
.header .form-switch svg.dark-icon {
  left: 5px;
}
.header .headerright {
  background: #ffffff;
  padding: 8px 15px;
  border-radius: 50px;
}
.header .headerright .linksheader svg {
  font-size: 16px;
  color: #000000;
}
.header .headerright .dropdown {
  display: inline-flex;
}
.header .headerright .dropdown .dropdown-toggle {
  background: transparent !important;
  border: none !important;
}
.header .headerright .dropdown .dropdown-toggle span {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  color: #000000;
}
.header .headerright .dropdown .dropdown-toggle span svg {
  margin-left: 5px;
}
.header .headerright .dropdown .dropdown-toggle::after {
  display: none;
}
.header .headerright .dropdown .dropdown-item {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
}
.header .headerright .dropdown .dropdown-item svg {
  margin-right: 5px;
}
.header .headerright .dropdown .dropdown-item.active {
  color: #3c5b8a;
  background: transparent;
}
.header .headerright a {
  display: inline-flex;
}
.header .headerright a:hover {
  opacity: 0.75;
  cursor: pointer;
}
.header .headerright img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

/*Header Css Ends*/
/*After Login Css Start*/
.mainbreadcrumb h1 {
  font-size: 28px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 0px;
}
.mainbreadcrumb nav ol {
  margin-bottom: 5px;
}
.mainbreadcrumb nav ol li a {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}
.mainbreadcrumb nav ol li.active {
  color: rgba(255, 255, 255, 0.5);
}
.mainbreadcrumb nav ol li.active:before {
  color: rgba(255, 255, 255, 0.5);
}

.min-width-159 {
  min-width: 159px;
}

.min-max-width-159 {
  min-width: 159px;
  max-width: 159px;
}

.min-width-147 {
  min-width: 147px;
}

.wrapper {
  background: #F6F6F6 !important;
  min-height: 100vh;
}
.wrapper .maincontent_div {
  backface-visibility: hidden;
  margin-left: 270px;
  padding: 15px;
  position: relative;
  transition: all 0.3s ease;
}
.wrapper .maincontent_div .stats {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.07);
  min-height: 110px;
  padding: 20px;
}
.wrapper .maincontent_div .stats h4 {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 400;
  margin: 0;
}
.wrapper .maincontent_div .stats p {
  font-size: 22px;
  color: #000000;
  font-weight: bold;
  margin: 0;
}
.wrapper .maincontent_div .stats .statsicon {
  background: rgba(94, 207, 255, 0.1);
  border-radius: 12px;
  height: 65px;
  width: 65px;
  min-width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.wrapper .maincontent_div .stats .statsicon img {
  height: 29px;
  object-fit: contain;
}
.wrapper .maincontent_div .stats .statsicon.statsdarkpurple {
  background: rgba(100, 24, 195, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statsdarkpurple svg {
  color: #6418C3;
}
.wrapper .maincontent_div .stats .statsicon.statsred {
  background: rgba(225, 31, 38, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statsred svg {
  color: #E11F26;
}
.wrapper .maincontent_div .stats .statsicon.statspurple {
  background: rgba(115, 103, 240, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statspurple svg {
  color: #7367F0;
}
.wrapper .maincontent_div .stats .statsicon.statsgreen {
  background: rgba(1, 148, 60, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statsgreen svg {
  color: #01943C;
}
.wrapper .maincontent_div .stats .statsicon.statsdarkgreen {
  background: rgba(42, 92, 23, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statsdarkgreen svg {
  color: #2A5C17;
}
.wrapper .maincontent_div .stats .statsicon.statsdarkblue {
  background: rgba(31, 46, 96, 0.1);
}
.wrapper .maincontent_div .stats .statsicon.statsdarkblue svg {
  color: #1F2E60;
}
.wrapper .maincontent_div .stats .statsicon svg {
  color: #5ECFFF;
  font-size: 29px;
}
.wrapper .maincontent_div .recharts-wrapper .recharts-legend-wrapper {
  background: #ffffff;
  padding: 10px 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
}
@media only screen and (max-width: 991.98px) {
  .wrapper .maincontent_div .recharts-wrapper .recharts-legend-wrapper {
    display: none;
  }
}
.wrapper .maincontent_div .recharts-wrapper .recharts-legend-wrapper .recharts-default-legend li.recharts-legend-item {
  opacity: 0.5;
}
.wrapper .maincontent_div .recharts-wrapper .recharts-legend-wrapper .recharts-default-legend li.recharts-legend-item .recharts-legend-item-text {
  color: #000000 !important;
  font-size: 12px;
}
.wrapper .maincontent_div .recharts-wrapper .recharts-default-tooltip .recharts-tooltip-label {
  color: #000000 !important;
  font-weight: bold;
}
.wrapper .maincontent_div .recharts-wrapper .recharts-default-tooltip .recharts-tooltip-item-list li {
  font-size: 12px;
  color: #000000 !important;
}
.wrapper .maincontent_div .card {
  --bs-border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}
.wrapper .maincontent_div .card .card-header {
  background: #ffffff;
  padding-bottom: 12px;
  padding-top: 12px;
}
.wrapper .maincontent_div .card .card-header h5 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0;
  color: #000000;
}
.wrapper .maincontent_div .card .card-header .OrderCount_Date {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin: 0px 10px;
}
.wrapper .maincontent_div .card .card-header .btnaccept, .wrapper .maincontent_div .card .card-header .btnreject {
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  padding: 0px 15px;
  display: inline-flex;
  align-items: center;
  border-radius: 30px;
}
.wrapper .maincontent_div .card .card-header .btnaccept svg, .wrapper .maincontent_div .card .card-header .btnreject svg {
  font-size: 18px;
  margin-right: 5px;
}
.wrapper .maincontent_div .card .card-header .btnaccept {
  color: #3c5b8a;
  border: 1px solid #3c5b8a;
}
.wrapper .maincontent_div .card .card-header .btnaccept:hover {
  background: #3c5b8a;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-header .btnreject {
  color: #E11F26;
  border: 1px solid #E11F26;
}
.wrapper .maincontent_div .card .card-header .btnreject:hover {
  background: #E11F26;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .btnnote {
  align-items: center;
  border: 1px solid #000000;
  border-radius: 50px;
  color: #000000;
  display: inline-flex;
  font-size: 13px;
  font-weight: 500;
  height: 32px;
  justify-content: center;
  min-width: 110px;
  text-decoration: none;
}
.wrapper .maincontent_div .card .card-body .btnnote:hover {
  background: #000000;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .customtabs.nav-tabs {
  border: none;
}
.wrapper .maincontent_div .card .card-body .customtabs.nav-tabs li.nav-item button.nav-link {
  border: 1px solid rgba(31, 46, 96, 0.1);
  border-radius: 40px;
  color: #1F2E60;
  font-weight: 500;
  padding: 10px 20px;
  font-size: 15px;
  margin: 0px 5px 10px 0px;
  background: rgba(31, 46, 96, 0.1);
  min-width: 170px;
}
.wrapper .maincontent_div .card .card-body .customtabs.nav-tabs li.nav-item button.nav-link.active, .wrapper .maincontent_div .card .card-body .customtabs.nav-tabs li.nav-item button.nav-link:hover {
  background: #1F2E60;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .searchfield svg {
  font-size: 18px;
  left: 15px;
  min-width: 18px;
  opacity: 0.5;
  position: absolute;
  top: 15px;
}
.wrapper .maincontent_div .card .card-body .searchfield .form-control {
  padding-left: 42px !important;
}
.wrapper .maincontent_div .card .card-body .btnedit {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1F2E60;
  color: #1F2E60;
  border-radius: 50%;
}
.wrapper .maincontent_div .card .card-body .btnedit:hover {
  background: #1F2E60;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .workorders {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.7);
}
.wrapper .maincontent_div .card .card-body .workorders:hover {
  color: #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .orders-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  padding: 20px;
  height: 100%;
}
.wrapper .maincontent_div .card .card-body .orders-card label {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  min-width: 100px;
  margin-right: 10px;
}
.wrapper .maincontent_div .card .card-body .orders-card span {
  font-size: 14px;
  color: #000000;
  font-weight: 300;
}
.wrapper .maincontent_div .card .card-body .orders-card h4 {
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.wrapper .maincontent_div .card .card-body .orders-card p {
  font-size: 14px;
  color: #000000;
  margin-bottom: 10px;
}
.wrapper .maincontent_div .card .card-body .btnaccept, .wrapper .maincontent_div .card .card-body .btnreject {
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  height: 30px;
  padding: 0px 10px;
  display: inline-flex;
  align-items: center;
  border-radius: 30px;
}
.wrapper .maincontent_div .card .card-body .btnaccept svg, .wrapper .maincontent_div .card .card-body .btnreject svg {
  font-size: 18px;
  margin-right: 5px;
}
.wrapper .maincontent_div .card .card-body .btnaccept {
  color: #3c5b8a;
  border: 1px solid #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .btnaccept:hover {
  background: #3c5b8a;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .btnreject {
  color: #E11F26;
  border: 1px solid #E11F26;
}
.wrapper .maincontent_div .card .card-body .btnreject:hover {
  background: #E11F26;
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .statusnew {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #01943C !important;
  background: rgba(1, 148, 60, 0.1);
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
  text-transform: capitalize;
}
.wrapper .maincontent_div .card .card-body .statuscancle {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: red !important;
  background: rgba(255, 0, 0, 0.1);
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
  text-transform: capitalize;
}
.wrapper .maincontent_div .card .card-body .download-wo-allfiles {
  border: 1px dashed rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  padding: 15px;
}
.wrapper .maincontent_div .card .card-body .download-wo-allfiles svg {
  font-size: 32px;
  color: #000000;
  margin-bottom: 5px;
}
.wrapper .maincontent_div .card .card-body .download-wo-allfiles p {
  font-size: 12px;
  color: #000000;
  text-align: center;
}
.wrapper .maincontent_div .card .card-body .badgestatus {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
}
.wrapper .maincontent_div .card .card-body .orders-shipping {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 18px 15px;
  border-radius: 12px;
  color: rgba(0, 0, 0, 0.7);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.wrapper .maincontent_div .card .card-body .orders-shipping b {
  font-weight: 500;
}
.wrapper .maincontent_div .card .card-body .orders-detail {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 18px 15px;
  border-radius: 12px;
  color: rgba(0, 0, 0, 0.7);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}
.wrapper .maincontent_div .card .card-body .orders-detail::-webkit-scrollbar {
  height: 5px;
}
.wrapper .maincontent_div .card .card-body .orders-detail::-webkit-scrollbar-thumb {
  background: #c5c4c4;
}
.wrapper .maincontent_div .card .card-body .orders-detail .form-check-input {
  width: 22px;
  height: 22px;
  border-color: rgba(0, 0, 0, 0.3);
  box-shadow: none;
}
.wrapper .maincontent_div .card .card-body .orders-detail .form-check-input:checked {
  background-color: #000000;
  border-color: #000000;
}
.wrapper .maincontent_div .card .card-body .list-main .w-40 {
  width: 40%;
}
@media only screen and (max-width: 1299.98px) {
  .wrapper .maincontent_div .card .card-body .list-main .w-40 {
    width: initial;
  }
}
.wrapper .maincontent_div .card .card-body .list-main .w-20 {
  width: 20%;
}
@media only screen and (max-width: 1299.98px) {
  .wrapper .maincontent_div .card .card-body .list-main .w-20 {
    width: initial;
  }
}
.wrapper .maincontent_div .card .card-body .list-main .list-qty .qty {
  height: 25px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  padding: 0px 10px;
  color: #000000;
}
.wrapper .maincontent_div .card .card-body .list-main .list-qty .qty strong {
  font-weight: 500;
}
.wrapper .maincontent_div .card .card-body .list-main .list-qty .price-total {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-img-outer {
  text-align: center;
  width: 160px;
  min-width: 160px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-img-outer .list-img {
  width: 160px;
  min-width: 160px;
  height: 160px;
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-img-outer .list-img .bublenumber {
  position: absolute;
  top: -10px;
  left: -10px;
  background: #98c1eb;
  display: inline-block;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  padding: 2px 7px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-img-outer .list-img img {
  object-fit: scale-down;
  padding: 10px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-img-outer span {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-content {
  padding-left: 15px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-content h2 {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 3px;
  max-width: 200px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-left .list-content h2 svg {
  font-size: 26px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-checkboxes .CuttingCheck_div p {
  display: flex;
  align-items: center;
  gap: 5px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-checkboxes .CuttingCheck_div p .custom-label-tag {
  margin-bottom: 0px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-checkboxes .postOpsCheckbox_div .postOpsCheckbox_box {
  gap: 5px;
  margin-bottom: 10px;
}
.wrapper .maincontent_div .card .card-body .list-main .list-checkboxes .postOpsCheckbox_div .postOpsCheckbox_box span {
  background: #ff8cd3;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 12px;
  line-height: normal;
  border-radius: 10px;
  display: inline-block;
}
.wrapper .maincontent_div .card .card-body .list-main .list-checkboxes .custom-label {
  height: 25px;
  padding: 0px 10px;
  font-size: 12px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  line-height: 25px;
  border-radius: 30px;
  margin-bottom: 7px;
  white-space: nowrap;
}
.wrapper .maincontent_div .card .card-body .list-main .list-attachment img {
  height: 32px;
  object-fit: contain;
}
.wrapper .maincontent_div .card .card-body .list-main .list-attachment span {
  font-size: 12px;
  color: #000000;
  margin-top: 5px;
}
.wrapper .maincontent_div .card .card-body .list-main:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 15px;
  margin-bottom: 20px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom {
  border-collapse: initial;
  border-spacing: 0 0.75em;
  margin-bottom: 0;
  padding: 5px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .form-check-input {
  width: 22px;
  height: 22px;
  border-color: rgba(0, 0, 0, 0.3);
  box-shadow: none;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .form-check-input:checked {
  background-color: #3c5b8a;
  border-color: #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-left: none;
  border-right: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  font-weight: 400;
  height: 60px;
  padding: 15px 15px;
  vertical-align: middle;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td b {
  font-weight: 500;
  margin-right: 5px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px 0 0 12px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td:last-child {
  border-radius: 0 12px 12px 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td:last-child button svg {
  font-size: 22px;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr td {
    font-size: 12px;
  }
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .checkbox-top .form-check {
  padding-left: 0;
  padding-right: 1.5em;
  display: inline-flex;
  align-items: center;
  flex-direction: row-reverse;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .checkbox-top .form-check .form-check-input {
  margin: 0;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .checkbox-top .form-check .form-check-label {
  font-size: 16px;
  color: #000000;
  margin-right: 10px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .workorders {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  margin-top: 10px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .upload-download {
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px dashed rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 8px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .upload-download svg {
  font-size: 32px;
  color: #000000;
  margin-bottom: 5px;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr .expanded-top .upload-download span {
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr.expanded-row td {
  border-top: 1px solid #3c5b8a;
  border-bottom: 1px solid #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr.expanded-row td:first-child {
  border-left: 1px solid #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .table.tablecustom tbody tr.expanded-row td:last-child {
  border-right: 1px solid #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .form-group .form-label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 4px;
}
.wrapper .maincontent_div .card .card-body .form-group .form-check.form-switch .form-check-input:checked {
  background-color: #3c5b8a;
  border-color: #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .form-group .quill .ql-toolbar.ql-snow {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
}
.wrapper .maincontent_div .card .card-body .form-group .quill .ql-container.ql-snow {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-top: 0;
  border-radius: 0px 0px 12px 12px;
}
.wrapper .maincontent_div .card .card-body .form-group .password-input-group svg {
  position: absolute;
  top: 17px;
  right: 20px;
  opacity: 0.3;
}
.wrapper .maincontent_div .card .card-body .form-group .form-control, .wrapper .maincontent_div .card .card-body .form-group .form-select {
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.7);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
}
.wrapper .maincontent_div .card .card-body .form-group .form-control[type=password], .wrapper .maincontent_div .card .card-body .form-group .form-select[type=password] {
  padding-right: 50px;
}
.wrapper .maincontent_div .card .card-body .form-group .form-control:focus, .wrapper .maincontent_div .card .card-body .form-group .form-select:focus {
  box-shadow: none;
}
.wrapper .maincontent_div .card .card-body .form-group .form-control::placeholder, .wrapper .maincontent_div .card .card-body .form-group .form-select::placeholder {
  color: #000000;
  opacity: 0.5;
}
.wrapper .maincontent_div .card .card-body .profileuser {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 30px 20px;
}
.wrapper .maincontent_div .card .card-body .profileuser .userinfo {
  width: 124px;
  height: 124px;
  border: 5px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-bottom: 20px;
}
.wrapper .maincontent_div .card .card-body .profileuser .userinfo img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.wrapper .maincontent_div .card .card-body .profileuser .userinfo label {
  width: 34px;
  height: 34px;
  background: #1F2E60;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin-bottom: 0;
  cursor: pointer;
}
.wrapper .maincontent_div .card .card-body .profileuser .userinfo label svg {
  color: #ffffff;
}
.wrapper .maincontent_div .card .card-body .profileuser h4 {
  font-size: 20px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 5px;
}
.wrapper .maincontent_div .card .card-body .profileuser p {
  font-size: 16px;
  color: #6C6A72;
  margin-bottom: 0;
}
.wrapper .maincontent_div .card .card-body .payment-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  padding: 20px;
}
.wrapper .maincontent_div .card .card-body .payment-card label {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  min-width: 105px;
  margin-right: 10px;
}
.wrapper .maincontent_div .card .card-body .payment-card span {
  font-size: 14px;
  color: #000000;
  font-weight: 300;
  line-height: normal;
}
.wrapper .maincontent_div .card .card-body .payment-card span.statusactive {
  height: 25px;
  background: rgba(1, 148, 60, 0.1);
  color: #01943C;
  padding: 0px 15px;
  line-height: 25px;
  border-radius: 50px;
  font-weight: 500;
}
.wrapper .maincontent_div .card .card-body .viewpaymentdetail p {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #000000;
}
.wrapper .maincontent_div .card .card-body .btnview, .wrapper .maincontent_div .card .card-body .btndelete {
  align-items: center;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 18px;
  height: 35px;
  justify-content: center;
  margin: 0 3px;
  min-width: 35px;
  width: 35px;
}
.wrapper .maincontent_div .card .card-body .btnview:hover, .wrapper .maincontent_div .card .card-body .btndelete:hover {
  opacity: 0.75;
}
.wrapper .maincontent_div .card .card-body .btnview {
  background: #3c5b8a;
}
.wrapper .maincontent_div .card .card-body .btndelete {
  background: #E11F26;
}
.wrapper .maincontent_div .card .card-body .files-image {
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper .maincontent_div .card .card-body .files-image img {
  height: 41px;
}
.wrapper .maincontent_div .card .card-body .table-responsive::-webkit-scrollbar {
  height: 5px;
}
.wrapper .maincontent_div .card .card-body .table-responsive::-webkit-scrollbar-thumb {
  background: #c5c4c4;
}
.wrapper .maincontent_div .card .card-body .custom-table::-webkit-scrollbar {
  height: 5px;
}
.wrapper .maincontent_div .card .card-body .custom-table::-webkit-scrollbar-thumb {
  background: #c5c4c4;
}
.wrapper .maincontent_div .card .card-body .custom-table .rdt_TableHead .rdt_TableHeadRow {
  background: #FAFAFA;
  border-radius: 12px;
  margin: 5px 0;
  padding-top: 15px;
  padding-bottom: 15px;
  min-height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.wrapper .maincontent_div .card .card-body .custom-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
.wrapper .maincontent_div .card .card-body .custom-table .rdt_TableBody .rdt_TableRow {
  min-height: 60px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 5px 0;
}
.wrapper .maincontent_div .card .card-body .custom-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
}
.wrapper .maincontent_div .card .card-body .custom-table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {
  white-space: pre-wrap;
}
.wrapper .maincontent_div .card .card-body .ShippingPackageOrder_info {
  align-items: center;
  margin-bottom: 10px;
}
.wrapper .maincontent_div .card .card-body .ShippingPackageOrder_info .gap_10 {
  gap: 10px;
  flex-wrap: wrap;
}
.wrapper .maincontent_div .card .card-body .ShippingPackageOrder_info p {
  border-radius: 5px;
  padding: 10px 20px;
  background: #ffffff;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  margin: 0px;
}
.wrapper .maincontent_div .card .card-body .ShippingPackageOrder_info .downloadLabel_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4e8ac8;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  text-decoration: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .ShippingPackageOrder_info .RefundLabel_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ff8282;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  text-decoration: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .PackagePurchase_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4e8ac8;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .PackageCompleteOrder_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #a6c3e2;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .PackageAddAnother_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #00bf63;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .PackageRemove_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #ca0000;
  border: 1px solid #ca0000;
  font-size: 22px;
  padding: 10px 12px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div {
  display: flex;
  align-items: center;
  gap: 30px;
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div .RefundLabel_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ff8282;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  text-decoration: none;
  border: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div .dimensionShowCheckbox_div {
  display: flex;
  align-items: center;
  margin: 5px 0px;
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div .dimensionShowCheckbox_div input[type=checkbox] {
  -webkit-appearance: none;
  -moz-appearance: none;
  margin-right: 5px;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background-color: #fff;
  border-radius: 4px;
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div .dimensionShowCheckbox_div input[type=checkbox]:checked {
  background-color: rgba(0, 0, 0, 0.6); /* Light gray */
  border-color: rgba(0, 0, 0, 0.6);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.wrapper .maincontent_div .card .card-body .dimensionShow_div .dimensionShowCheckbox_div label {
  font-size: 16px;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .ShippingMethodmain_title {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 10px;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .gap_20 {
  gap: 40px;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .getRate_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4e8ac8;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  height: 42px;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .PachageField_label {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  line-height: normal;
  color: #000;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .PackageFieldSubtitle {
  font-size: 14px;
  font-weight: 500;
  margin-top: 5px;
  line-height: normal;
  color: #000;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #000000;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex .PachageField_box {
  position: relative;
  width: 100%;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex .PachageField_box input.PachageField_number {
  height: 42px;
  border-radius: 5px;
  padding: 4px 10px 4px 30px;
  text-align: right;
  background: #ffffff;
  box-sizing: border-box;
  display: inline-block;
  outline: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex .PachageField_box input.PachageField_number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex .PachageField_box .PachageField_Size {
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  color: #000000;
  font-size: 14px;
  padding: 2px 5px;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex .PachageFieldSizeSelect {
  height: 42px;
  border-radius: 5px;
  padding: 4px 10px;
  text-align: left;
  background-color: #ffffff;
  box-sizing: border-box;
  display: inline-block;
  outline: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
}
.wrapper .maincontent_div .card .card-body .packageDeminsionMain_div .DeminsionMain_div .PachageField_div .DeminsionField_flex.max_250 {
  width: 100%;
  max-width: 250px;
  margin: 0px;
}

.custom-label-tag {
  height: 25px;
  padding: 0px 10px;
  font-size: 12px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  line-height: 25px;
  border-radius: 30px;
  margin-bottom: 7px;
  white-space: nowrap;
}

@media only screen and (max-width: 767.98px) {
  .header,
  .maincontent_div {
    margin-left: 0 !important;
  }
}
/*After Login Css Ends*/
.sortByMain_box {
  display: flex;
  gap: 0px 20px;
  margin-bottom: 10px;
}
.sortByMain_box .sortByMain_head {
  display: inline-flex;
  align-items: flex-start;
  min-width: 120px;
  justify-content: flex-end;
  margin-right: 10px;
  flex-shrink: 0;
}
.sortByMain_box .sortByMain_head .sortByHead_box {
  display: inline-flex;
  background: #d9d9d9;
  color: #000000;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
}
.sortByMain_box .sortByMain_head .sortByFilterBtn {
  position: relative;
  font-size: 18px;
  color: #000000;
  display: inline-flex;
}
.sortByMain_box .sortByMain_head .sortByFilterBtn .sortFilterClose {
  position: absolute;
  font-size: 14px;
  border: 1px solid #fff;
  border-radius: 50%;
  bottom: 0px;
  right: -6px;
}
.sortByMain_box .SortFilterBtnBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex-grow: 1;
}
.sortByMain_box .SortFilterBtnBox .SortFilter_btn {
  display: inline-flex;
  background: #d9d9d9;
  color: #000000;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-transform: uppercase;
  border: 0px;
  line-height: normal;
}
.sortByMain_box .SortFilterBtnBox .SortFilter_btn.active {
  background: #ff8cd3;
}
.sortByMain_box .SortFilterBtnBox .SortFilter_btn:hover {
  background: #ff8cd3;
}
.sortByMain_box .tagFilterBtnBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex-grow: 1;
}
.sortByMain_box .tagFilterBtnBox .tagFilter_btn {
  display: inline-flex;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-transform: uppercase;
  border: 0px;
  line-height: normal;
}
.sortByMain_box .tagFilterBtnBox .tagFilter_btn_cutting {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-transform: uppercase;
  border: 0px;
  line-height: normal;
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
  min-width: 70px;
  width: 70px;
}
.sortByMain_box .tagFilterBtnBox .tagFilter_btn_cutting:hover {
  filter: brightness(0.85);
  transform: translateY(-1px);
}
.sortByMain_box .tagFilterBtnBox .tagFilter_btn_cutting.active {
  filter: brightness(0.75);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.SearchFilterfield {
  position: relative;
}
.SearchFilterfield .form-control {
  padding-left: 42px !important;
}
.SearchFilterfield .search_icon {
  font-size: 18px;
  left: 15px;
  min-width: 18px;
  opacity: 0.5;
  position: absolute;
  top: 15px;
}
.SearchFilterfield .sortByFilterBtn {
  position: absolute;
  right: -15px;
  top: 0px;
  font-size: 18px;
  color: #000000;
  display: inline-flex;
}
.SearchFilterfield .sortByFilterBtn .sortFilterClose {
  position: absolute;
  font-size: 14px;
  border: 1px solid #fff;
  border-radius: 50%;
  bottom: 0px;
  right: -6px;
}

.datamain .btndata {
  background: #d0e7ff;
  color: #5b92cd;
  font-size: 12px;
  text-decoration: none;
  text-transform: uppercase;
  padding: 3px 6px;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.datamain .btndata:hover {
  opacity: 0.75;
}

.postion_take {
  font-size: 18px;
  right: 8px;
  min-width: 18px;
  opacity: 0.5;
  position: absolute;
  top: 10px;
}

.btntrash {
  width: 25px;
  height: 25px;
  background: #E11F26;
  color: #ffffff;
  min-width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 14px;
}

.statusactiveData {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: red !important;
  background: rgba(255, 0, 0, 0.1);
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
  text-transform: capitalize;
}

.statusactiveNew {
  font-size: 12px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(1, 148, 60, 0.1);
  color: #01943C;
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
  text-transform: capitalize;
}

.refund-content p {
  font-size: 14px;
  font-weight: 400;
}
.refund-content p a {
  text-decoration: underline;
  color: #3c5b8a;
  font-weight: 500;
}

.removefileimg {
  position: absolute;
  right: 0;
  top: 0;
}

.tracking-info.custom_rate p .maxwidth130 {
  max-width: 130px;
  display: inline-block;
  width: 100%;
}

.formtable.table > :not(caption) > * > * {
  border-bottom: none;
  background-color: transparent;
}
.formtable tr td input[type=checkbox] {
  width: 17px !important;
  height: 17px !important;
}

.nopermission .card-body {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.nopermission h1 {
  font-size: 40px;
  margin: 12px 0;
}
.nopermission p {
  margin-bottom: 0;
}

.w-40 {
  width: 40%;
}
@media only screen and (max-width: 1199.98px) {
  .w-40 {
    width: initial;
  }
}

.w-10 {
  width: 20%;
}
@media only screen and (max-width: 1199.98px) {
  .w-10 {
    width: initial;
  }
}

.py-85rem {
  padding-top: 0.85rem !important;
  padding-top: 0.85rem !important;
}

.fileuploadedgrid {
  width: 100px;
  height: 100px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  position: relative;
}
.fileuploadedgrid .btn-close {
  width: 12px;
  height: 12px;
  opacity: 1;
  background-color: #E11F26;
  --bs-btn-close-bg:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-radius: 50%;
  background-size: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.filegrid {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
}
.filegrid .btn-close {
  width: 12px;
  height: 12px;
  opacity: 1;
  background-color: #E11F26;
  --bs-btn-close-bg:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-radius: 50%;
  background-size: 10px;
}

.quote_scroll_clss {
  scrollbar-width: none;
  height: auto !important;
  overflow: visible !important;
}
.quote_scroll_clss > div {
  height: auto !important;
}
.quote_scroll_clss .quote_lisiting_pge {
  position: initial !important;
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/employee/assets/css/style.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACI,SAAA;EACA,UAAA;AADJ;;AAIA;;;EAGI,gCCyCU;AD1Cd;;AAIA;;EAEI,oCAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAKI;EADJ;IAEQ,kBAAA;EADN;AACF;;AAIA;EACI,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AADJ;AAGI;EACI,eAAA;EACA,kBAAA;AADR;AAII;EAhBJ;IAiBQ,0BAAA;EADN;AACF;AAGI;EACI,aAAA;EACA,yBAAA;AADR;;AAKA;EACI,8BAAA;EACA,gCAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;AAFJ;AAII;EACI,eAAA;EACA,kBAAA;AAFR;AAKI;EAhBJ;IAiBQ,0BAAA;EAFN;EAIM;IACI,eAAA;EAFV;AACF;AAKI;EACI,aAAA;EACA,yBAAA;AAHR;;AAOA;EACI,8CAAA;EACA,gDAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;AAJJ;AAMI;EACI,eAAA;EACA,kBAAA;AAJR;AAOI;EAhBJ;IAiBQ,0BAAA;EAJN;EAMM;IACI,eAAA;EAJV;AACF;AAOI;EACI,aAAA;EACA,yBAAA;AALR;;AASA,mBAAA;AACA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBC5EU;ED6EV,aAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAQI;EACI,aAAA;EACA,2BAAA;AANR;AASI;EAEI;IAEI,mBAAA;IACA,UAAA;EATV;EAYM;IACI,qBAAA;IACA,UAAA;EAVV;AACF;;AAcA,kBAAA;AACA,iBAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;AAXJ;AAaI;EACI,iBAAA;EACA,oBAAA;AAXR;AAcI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,mBC1HM;ED2HN,kDAAA;AAZR;AAcQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AAZZ;AAgBI;EACI,mBCpIM;EDqIN,aAAA;EACA,mBAAA;EACA,4CAAA;AAdR;AAgBQ;EANJ;IAOQ,aAAA;EAbV;AACF;AAeQ;EAVJ;IAWQ,aAAA;EAZV;EAaU;IACI,0BAAA;EAXd;AACF;AAeY;EACI,eAAA;EACA,cCzJF;ED0JE,gBAAA;AAbhB;AAgBY;EACI,eAAA;EACA,cCjKE;EDkKF,gBAAA;EACA,gBAAA;EACA,cAAA;AAdhB;AAmBY;EACI,cCxKF;EDyKE,gBAAA;EACA,qBAAA;EACA,eAAA;AAjBhB;AAqBQ;EACI,eAAA;EACA,cCjLE;AD8Jd;AAqBY;EACI,cCnNA;EDoNA,gBAAA;EACA,qBAAA;AAnBhB;AAyBY;EACI,eAAA;EACA,gBAAA;EACA,cC/LF;ADwKd;AAyBgB;EACI,YAAA;AAvBpB;AA4BgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AA1BpB;AA6BY;EAEI,SAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AA5BhB;AA6BgB;EACI,oCAAA;AA3BpB;AA6BgB;EAZJ;IAcQ,SAAA;IACA,YAAA;EA3BlB;AACF;AA6BY;EACI,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA3BhB;AA6BgB;EACI,mBAAA;AA3BpB;AA8BgB;EACI,gBAAA;AA5BpB;AA+BgB;EACI,cClPN;EDmPM,YAAA;AA7BpB;;AAuCY;EACI,0BAAA;EACA,2BAAA;AApChB;AAqCgB;EACI,gBAAA;AAnCpB;AAwCY;EACI,gBAAA;AAtChB;AAwCY;EACI,kBAAA;AAtChB;AA8CiB;EACG,eAAA;EACA,cCpRN;EDqRM,iBAAA;AA5CpB;AA+CY;EACI,WAAA;EACA,YAAA;EACA,yBC1TA;ED2TA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yDAAA;AA7ChB;AAgDgB;EACI,iBAAA;EACA,gBAAA;AA9CpB;AA+CoB;EACI,UAAA;AA7CxB;AA+CsB;EACE,gBAAA;AA7CxB;AA+CoB;EACM,qCAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;AA7C1B;AA8C0B;EAEE,mBAAA;AA7C5B;AA+C0B;EACI,cC9ThB;ED+TgB,eAAA;AA7C9B;AA+C0B;EACI,cClUhB;EDmUgB,eAAA;EACA,eAAA;EACA,eAAA;AA7C9B;AAiDgB;EACI,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,cC7UN;ED8UM,kBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAhDpB;AAiDoB;EACI,gBAAA;AA/CxB;AAkDoB;EACI,cCzVV;ED0VU,YAAA;AAhDxB;;AAwDI;EACI,gBAAA;AArDR;AAuDQ;EACI,mBAAA;AArDZ;AAuDY;EACI,kBAAA;EACA,aAAA;AArDhB;AAuDgB;EACI,eAAA;EACA,cC9WN;ED+WM,gBAAA;AArDpB;AAwDgB;EACI,eAAA;EACA,cCtXF;EDuXE,gBAAA;EACA,gBAAA;AAtDpB;AAyDgB;EACI,gBAAA;AAvDpB;;AA8DA,gBAAA;AAEA,oBAAA;AAEA;EACI,mBCpYU;EDqYV,YAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,qBAAA;EACA,4CAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;AA7DJ;AA+DI;EACI,kBAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;AA7DR;AA+DQ;EACI,YAAA;AA7DZ;AAiEI;EACI;IACI,OAAA;IACA,8BAAA;EA/DV;EAkEM;IACI,YAAA;IACA,8BAAA;EAhEV;AACF;;AAoEA;EACI;IACI,8BAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,eAAA;IACA,MAAA;IACA,8BAAA;EAjEN;EAmEM;IACI,8BAAA;IACA,WAAA;EAjEV;AACF;AA0EgB;EACI,aAAA;AAxEpB;AA6EI;EACI,kBAAA;EACA,kBAAA;EACA,cC3cM;ED4cN,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AA3ER;AA6EQ;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AA3EZ;AA8EQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBC7fI;ED8fJ,QAAA;EACA,gCAAA;AA5EZ;AA+EQ;EAMI,cCveE;EDweF,mBCzgBI;ED0gBJ,aAAA;EACA,kBAAA;AAlFZ;AA2EY;EACI,UAAA;AAzEhB;;AAmFA;EACI,cAAA;EACA,yBCjhBY;ADichB;;AAkFA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCzfU;ED0fV,cAAA;EACA,YAAA;EACA,iBAAA;AA/EJ;;AAiFA;EAEI;;IAEI,yBAAA;EA/EN;EAkFE;;IAEI,oBAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;EAhFN;EAmFE;IACI,kCAAA;IACA,2BAAA;IACA,UAAA;IACA,kBAAA;IACA,SAAA;EAjFN;EAmFM;IACI,eAAA;EAjFV;AACF;AAqFA,mBAAA;AACA,mBAAA;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AApFJ;AAsFI;EACI,kBAAA;AApFR;AAqFC;EACW,WAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,4DAAA;AAnFZ;AAqFY;EACI,yBC/iBF;AD4dd;AAsFY;EACI,4DAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AApFhB;AAwFQ;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cC5jBE;ADsed;AAwFY;EACI,UAAA;AAtFhB;AAyFY;EACI,SAAA;AAvFhB;AA6FI;EACI,mBC1kBM;ED2kBN,iBAAA;EACA,mBAAA;AA3FR;AA8FY;EACI,eAAA;EACA,cCnlBF;ADufd;AAgGQ;EACI,oBAAA;AA9FZ;AA+FY;EACI,kCAAA;EACA,uBAAA;AA7FhB;AA8FgB;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cChmBN;ADogBd;AA6FoB;EACI,gBAAA;AA3FxB;AA8FgB;EACI,aAAA;AA5FpB;AA+FY;EACI,oBAAA;EACA,mBAAA;EACA,eAAA;AA7FhB;AA8FgB;EACI,iBAAA;AA5FpB;AA8FgB;EACI,cChpBJ;EDipBI,uBAAA;AA5FpB;AAiGQ;EACI,oBAAA;AA/FZ;AAiGY;EACI,aAAA;EACA,eAAA;AA/FhB;AAqGQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAnGZ;;AAwGA,kBAAA;AACA,wBAAA;AAEI;EACI,eAAA;EACA,cC/oBM;EDgpBN,gBAAA;EACA,kBAAA;AAtGR;AA0GQ;EACI,kBAAA;AAxGZ;AA2GgB;EACI,cC1pBN;ED2pBM,eAAA;EACA,gBAAA;EACA,qBAAA;AAzGpB;AA2GgB;EAIO,+BAAA;AA5GvB;AAyGoB;EACI,+BAAA;AAvGxB;;AAgHA;EACI,gBAAA;AA7GJ;;AA+GA;EACI,gBAAA;EACA,gBAAA;AA5GJ;;AA8GA;EACI,gBAAA;AA3GJ;;AA8GA;EACI,8BAAA;EACA,iBAAA;AA3GJ;AA6GI;EAEI,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AA3GR;AA6GQ;EACI,mBChsBE;EDisBF,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,aAAA;AA3GZ;AA6GY;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AA3GhB;AA8GY;EACI,eAAA;EACA,cCjtBF;EDktBE,iBAAA;EACA,SAAA;AA5GhB;AA+GY;EACI,mCAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7GhB;AA+GgB;EACI,YAAA;EACA,mBAAA;AA7GpB;AAgHgB;EACI,mCAAA;AA9GpB;AAgHoB;EACI,cAAA;AA9GxB;AAkHgB;EACI,kCAAA;AAhHpB;AAkHoB;EACI,cC1wBT;AD0pBf;AAoHgB;EACI,oCAAA;AAlHpB;AAoHoB;EACI,cC7wBT;AD2pBf;AAsHgB;EACI,iCAAA;AApHpB;AAsHoB;EACI,cAAA;AApHxB;AAwHgB;EACI,iCAAA;AAtHpB;AAwHoB;EACI,cCjyBV;AD2qBd;AA0HgB;EACI,iCAAA;AAxHpB;AA0HoB;EACI,cChzBN;ADwrBlB;AA4HgB;EACI,cAAA;EACA,eAAA;AA1HpB;AAgIY;EACI,mBC7xBF;ED8xBE,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;AA9HhB;AAgIgB;EAPJ;IAQQ,aAAA;EA7HlB;AACF;AAiIwB;EACI,YAAA;AA/H5B;AAiI4B;EACI,yBAAA;EACA,eAAA;AA/HhC;AAuIgB;EACI,yBAAA;EACA,iBAAA;AArIpB;AAyIoB;EACI,eAAA;EACA,yBAAA;AAvIxB;AA8IQ;EACI,mCAAA;EACA,uBAAA;EACA,wCAAA;AA5IZ;AA8IY;EACI,mBC30BF;ED40BE,oBAAA;EACA,iBAAA;AA5IhB;AA8IgB;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCr1BN;ADysBd;AA8IgB;EACI,eAAA;EACA,gBAAA;EACA,cC11BN;ED21BM,gBAAA;AA5IpB;AA8IgB;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AA5IpB;AA6IoB;EACI,eAAA;EACA,iBAAA;AA3IxB;AA8IgB;EACI,cC14BJ;ED24BI,yBAAA;AA5IpB;AA6IoB;EACI,mBC74BR;ED84BQ,cC72BV;ADkuBd;AA8IgB;EACI,cC34BL;ED44BK,yBAAA;AA5IpB;AA6IoB;EACI,mBC94BT;ED+4BS,cCr3BV;AD0uBd;AAiJgB;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cCj4BN;EDk4BM,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;AA/IpB;AAgJoB;EACI,mBC14BV;ED24BU,cCz4BV;AD2vBd;AAkJoB;EACI,YAAA;AAhJxB;AAqJoC;EACI,uCAAA;EACA,mBAAA;EACA,cCt7BtB;EDu7BsB,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,iCAAA;EACA,gBAAA;AAnJxC;AAqJwC;EAEI,mBCh8B1B;EDi8B0B,cCj6B9B;AD6wBd;AA6JoB;EACI,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AA3JxB;AA6JoB;EACI,6BAAA;AA3JxB;AA8JkB;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cC79BF;ED89BE,kBAAA;AA5JpB;AA6JoB;EACI,mBCh+BN;EDi+BM,cCj8BV;ADsyBd;AA8JgB;EACI,qBAAA;EACA,yBAAA;AA5JpB;AA6JoB;EACI,cCz+BR;AD80BhB;AA8JgB;EACI,mBC58BN;ED68BM,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,YAAA;AA5JpB;AA6JoB;EACI,eAAA;EACA,cCt9BV;EDu9BU,gBAAA;EACA,gBAAA;EACA,kBAAA;AA3JxB;AA6JoB;EACI,eAAA;EACA,cC79BV;ED89BU,gBAAA;AA3JxB;AA6JoB;EACI,cCj+BV;EDk+BU,eAAA;EACA,gBAAA;EACA,mBAAA;AA3JxB;AA6JoB;EACI,eAAA;EACA,cCx+BV;EDy+BU,mBAAA;AA3JxB;AA8JgB;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AA5JpB;AA6JoB;EACI,eAAA;EACA,iBAAA;AA3JxB;AA8JgB;EACI,cC1hCJ;ED2hCI,yBAAA;AA5JpB;AA6JoB;EACI,mBC7hCR;ED8hCQ,cC7/BV;ADk2Bd;AA8JgB;EACI,cC3hCL;ED4hCK,yBAAA;AA5JpB;AA6JoB;EACI,mBC9hCT;ED+hCS,cCrgCV;AD02Bd;AA8JgB;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AA5JpB;AA8JgB;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AA5JpB;AA8JgB;EACI,qCAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;AA5JpB;AA6JoB;EACI,eAAA;EACA,cC7iCV;ED8iCU,kBAAA;AA3JxB;AA6JoB;EACI,eAAA;EACA,cCljCV;EDmjCU,kBAAA;AA3JxB;AA8JgB;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cC3jCN;ED4jCM,cAAA;EACA,YAAA;EACA,iBAAA;AA5JpB;AA8JgB;EACI,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;AA5JpB;AA6JoB;EACI,gBAAA;AA3JxB;AA8JgB;EACI,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,gBAAA;AA5JpB;AA6JoB;EACI,WAAA;AA3JxB;AA8JoB;EACI,mBAAA;AA5JxB;AA8JoB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;AA5JxB;AA6JwB;EACI,yBChmCd;EDimCc,qBCjmCd;ADs8Bd;AAgKoB;EACI,UAAA;AA9JxB;AA+JwB;EAFJ;IAGQ,cAAA;EA5J1B;AACF;AA8JoB;EACI,UAAA;AA5JxB;AA6JwB;EAFJ;IAGQ,cAAA;EA1J1B;AACF;AA6JwB;EACI,YAAA;EACA,+BAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cC5nCd;ADi+Bd;AA4J4B;EACI,gBAAA;AA1JhC;AA6JwB;EACI,eAAA;EACA,yBAAA;AA3J5B;AA+JwB;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AA7J5B;AA8J4B;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7JhC;AA8JgC;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AA5JpC;AA8JgC;EACG,sBAAA;EACA,aAAA;AA5JnC;AA+J4B;EACE,eAAA;EACA,yBAAA;AA7J9B;AAgKwB;EACI,kBAAA;AA9J5B;AA+J4B;EACG,eAAA;EACA,cChrCjB;EDirCiB,gBAAA;EACA,kBAAA;EACA,gBAAA;AA7J/B;AA8J+B;EACC,eAAA;AA5JhC;AAoK4B;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAlKhC;AAmKgC;EACI,kBAAA;AAjKpC;AAsK4B;EACI,QAAA;EACA,mBAAA;AApKhC;AAqKgC;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAnKpC;AAuKwB;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cCxtCd;EDytCc,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AArK5B;AAyKwB;EACI,YAAA;EACA,mBAAA;AAvK5B;AAyKwB;EACI,eAAA;EACA,cC1uCd;ED2uCc,eAAA;AAvK5B;AA0KoB;EACI,2CAAA;EACA,oBAAA;EACA,mBAAA;AAxKxB;AA4KoB;EACI,wBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;AA1KxB;AA4K4B;EACI,2CAAA;EACA,mBAAA;AA1KhC;AA6KgC;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;AA3KpC;AA4KoC;EACI,yBCryCxB;EDsyCwB,qBCtyCxB;AD4nChB;AA8KgC;EAuBI,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAlMpC;AAoKoC;EACI,gBAAA;EACA,iBAAA;AAlKxC;AAqKoC;EACI,yCAAA;EACA,4BAAA;AAnKxC;AAsKoC;EACI,4BAAA;EACA,0CAAA;AApKxC;AAuK4C;EACI,eAAA;EACA,cC7xClC;ADwnCd;AAoLoC;EAjCJ;IAkCQ,eAAA;EAjLtC;AACF;AAqLwC;EACI,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;AAnL5C;AAoL4C;EACI,SAAA;AAlLhD;AAoL4C;EACE,eAAA;EACA,cC7zChC;ED8zCgC,kBAAA;AAlL9C;AAsLoC;EACI,eAAA;EACA,cCp0C1B;EDq0C0B,gBAAA;EACA,gBAAA;AApLxC;AAsLoC;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,qCAAA;EACA,aAAA;EACA,kBAAA;AApLxC;AAqLwC;EACI,eAAA;EACA,cCj1C9B;EDk1C8B,kBAAA;AAnL5C;AAqLwC;EACI,eAAA;EACA,cCt1C9B;EDu1C8B,mBAAA;AAnL5C;AAyLwC;EACI,6BAAA;EACA,gCAAA;AAvL5C;AAwL4C;EACE,8BAAA;AAtL9C;AAwL4C;EACE,+BAAA;AAtL9C;AAgMoB;EACI,eAAA;EACA,gBAAA;EACA,cCj3CV;EDk3CU,kBAAA;AA9LxB;AAmMgC;EAEI,yBCx5CpB;EDy5CoB,qBCz5CpB;ADutChB;AAyM4B;EACI,qCAAA;EACA,gCAAA;AAvMhC;AA2M4B;EACI,qCAAA;EACA,aAAA;EACA,gCAAA;AAzMhC;AA8MwB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AA5M5B;AAgNoB;EACI,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA9MxB;AAgNwB;EACI,mBAAA;AA9M5B;AAiNwB;EACI,gBAAA;AA/M5B;AAkNwB;EACI,cCz6Cd;ED06Cc,YAAA;AAhN5B;AAqNgB;EACI,oCAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;AAnNpB;AAqNoB;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;AAnNxB;AAqNwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAnN5B;AAsNwB;EACI,WAAA;EACA,YAAA;EACA,mBCt+CV;EDu+CU,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AApN5B;AAsN4B;EACI,cCl9ClB;AD8vCd;AAyNoB;EACI,eAAA;EACA,cC39CV;ED49CU,gBAAA;EACA,kBAAA;AAvNxB;AA0NoB;EACI,eAAA;EACA,cCp+CN;EDq+CM,gBAAA;AAxNxB;AA4NgB;EACI,mBCt+CN;EDu+CM,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;AA1NpB;AA4NoB;EACI,eAAA;EACA,cCh/CV;EDi/CU,gBAAA;EACA,gBAAA;EACA,kBAAA;AA1NxB;AA6NoB;EACI,eAAA;EACA,cCx/CV;EDy/CU,gBAAA;EACA,mBAAA;AA3NxB;AA6NwB;EACI,YAAA;EACA,iCAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA3N5B;AAiOoB;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cC7gDV;AD8yCd;AAoOgB;EACI,mBAAA;EACA,kBAAA;EACA,cCnhDN;EDohDM,oBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAlOpB;AAqOoB;EACI,aAAA;AAnOxB;AAsOC;EACG,mBCnkDY;AD+1ChB;AAsOC;EACG,mBC/jDW;AD21Cf;AAsOgB;EACI,mBCxiDN;EDyiDM,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApOpB;AAsOoB;EACI,YAAA;AApOxB;AAwOoB;EACI,WAAA;AAtOxB;AAyOoB;EACI,mBAAA;AAvOxB;AA8OoB;EACI,WAAA;AA5OxB;AA+OoB;EACI,mBAAA;AA7OxB;AAiPwB;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AA/O5B;AAiP4B;EACI,cCxlDlB;EDylDkB,eAAA;EACA,gBAAA;AA/OhC;AAqPwB;EAYI,gBAAA;EACA,mBAAA;EACA,mBC5mDd;ED6mDc,oCAAA;EACA,aAAA;AA9P5B;AA+O4B;EACI,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AA7OhC;AA+OgC;EACI,qBAAA;AA7OpC;AAyPgB;EACI,mBAAA;EACA,mBAAA;AAvPpB;AAwPoB;EACI,SAAA;EACA,eAAA;AAtPxB;AAwPoB;EACI,kBAAA;EACA,kBAAA;EACA,mBC5nDV;ED6nDU,qBAAA;EACA,oCAAA;EACA,eAAA;EACA,WAAA;AAtPxB;AAwPoB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAtPxB;AAwPoB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAtPxB;AAyPgB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAvPpB;AAyPgB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAvPpB;AAyPgB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAvPpB;AAyPgB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAvPpB;AAyPgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAvPpB;AAwPoB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAtPxB;AAwPoB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAtPxB;AAuPwB;EACI,wBAAA;EACA,qBAAA;EAEA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sBAAA;EACA,kBAAA;AAtP5B;AAuP4B;EACI,oCAAA,EAAA,eAAA;EACA,gCAAA;EACA,yDAAA;AArPhC;AAwPwB;EACI,eAAA;AAtP5B;AA2PoB;EACI,eAAA;EACA,gBAAA;EACA,cC3wDV;ED4wDU,mBAAA;AAzPxB;AA2PoB;EACI,SAAA;AAzPxB;AA2PoB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAzPxB;AA6P4B;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA3PhC;AA6P4B;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AA3PhC;AA6P4B;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cCpzDlB;ADyjDd;AA4PgC;EACI,kBAAA;EACA,WAAA;AA1PpC;AA2PoC;EACI,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBC3zD1B;ED4zD0B,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AAzPxC;AA0PwC;EACI,wBAAA;EACA,SAAA;AAxP5C;AA2PoC;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cCn1D1B;EDo1D0B,eAAA;EACA,gBAAA;AAzPxC;AA6PgC;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBC51DtB;ED61DsB,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AA3PpC;AA6PgC;EACI,WAAA;EACA,gBAAA;EACA,WAAA;AA3PpC;;AAqQA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cCt3DU;EDu3DV,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlQJ;;AAoQA;EAEI;;IAEI,yBAAA;EAlQN;AACF;AAqQA,uBAAA;AACA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;AAnQJ;AAoQI;EACI,oBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAlQR;AAmQQ;EACI,oBAAA;EACA,mBAAA;EACA,cCv5DE;EDw5DF,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjQZ;AAmQQ;EACI,kBAAA;EACA,eAAA;EACA,cCh6DE;EDi6DF,oBAAA;AAjQZ;AAkQY;EACI,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAhQhB;AAoQI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAlQR;AAmQQ;EACI,oBAAA;EACA,mBAAA;EACA,cCr7DE;EDs7DF,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAjQZ;AAkQY;EACI,mBAAA;AAhQhB;AAkQY;EACI,mBAAA;AAhQhB;AAoQI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAlQR;AAmQQ;EAEI,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAlQZ;AAqQQ;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AApQZ;AAsQY;EACI,wBAAA;EACA,2BAAA;AApQhB;AAuQY;EACI,wBAAA;EACA,wCAAA;AArQhB;;AA2QA;EACI,kBAAA;AAxQJ;AAyQI;EACI,6BAAA;AAvQR;AAyQI;EACI,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AAvQR;AAyQI;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;EACA,cCxgEM;EDygEN,oBAAA;AAvQR;AAwQQ;EACI,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAtQZ;;AA2QI;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAxQR;AAyQQ;EACI,aAAA;AAvQZ;;AA4QA;EACI,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AAzQJ;;AA2QA;EACI,WAAA;EACA,YAAA;EACA,mBCzkEW;ED0kEX,cChjEU;EDijEV,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAxQJ;;AA2QA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AAxQJ;;AA2QA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AAxQJ;;AA2QI;EACI,eAAA;EACA,gBAAA;AAxQR;AAyQQ;EACI,0BAAA;EACA,cC7nEI;ED8nEJ,gBAAA;AAvQZ;;AA2QA;EACI,kBAAA;EACA,QAAA;EACA,MAAA;AAxQJ;;AA4QQ;EACI,gBAAA;EACA,qBAAA;EACA,WAAA;AAzQZ;;AA8QI;EACI,mBAAA;EACA,6BAAA;AA3QR;AAgRQ;EAEC,sBAAA;EACA,uBAAA;AA/QT;;AAqRI;EACI,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAlRR;AAoRI;EACI,eAAA;EACA,cAAA;AAlRR;AAoRI;EACI,gBAAA;AAlRR;;AAqRA;EACI,UAAA;AAlRJ;AAmRI;EAFJ;IAGQ,cAAA;EAhRN;AACF;;AAkRA;EACI,UAAA;AA/QJ;AAgRI;EAFJ;IAGQ,cAAA;EA7QN;AACF;;AA+QA;EACI,+BAAA;EACA,+BAAA;AA5QJ;;AA8QA;EACI,YAAA;EACA,aAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;AA3QJ;AA4QI;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBCnsEO;EDosEP,yDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AA1QR;;AA6QA;EACI,4CAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA1QJ;AA2QI;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBCvtEO;EDwtEP,yDAAA;EACA,kBAAA;EACA,qBAAA;AAzQR;;AA4QA;EACI,qBAAA;EACI,uBAAA;EACA,4BAAA;AAzQR;AA0QQ;EACQ,uBAAA;AAxQhB;AA0QM;EACF,4BAAA;EACA,uBAAA;AAxQJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\r\n@import \"../../../styles/variables\";\r\n\r\n* {\r\n    margin : 0;\r\n    padding: 0;\r\n}\r\n\r\nhtml,\r\nbody,\r\n* {\r\n    font-family: $font-family;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    background-color: $white-color !important;\r\n}\r\n\r\nbody {\r\n    overflow-x: hidden;\r\n}\r\n\r\nhtml {\r\n    @media only screen and (max-width:991.98px) {\r\n        overflow-x: hidden;\r\n    }\r\n}\r\n\r\n.btn-outline-primary {\r\n    background   : $white-color !important;\r\n    border       : 1px solid $primary-color !important;\r\n    color        : $primary-color !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $primary-color !important;\r\n    }\r\n}\r\n\r\n.btn-primary {\r\n    background   : $primary-color !important;\r\n    border-color : $primary-color !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    color        : $white-color !important;\r\n\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n\r\n        svg {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $white-color !important;\r\n    }\r\n}\r\n\r\n.btn-lt-primary {\r\n    background   : rgba($primary-color, .13) !important;\r\n    border-color : rgba($primary-color, .13) !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    color        : $primary-color !important;\r\n\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n\r\n        svg {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $primary-color !important;\r\n    }\r\n}\r\n\r\n/*Loader Css Start*/\r\n.loaderdiv {\r\n    position       : fixed;\r\n    top            : 0px;\r\n    bottom         : 0px;\r\n    left           : 0px;\r\n    right          : 0px;\r\n    z-index        : 111;\r\n    background     : $white-color;\r\n    display        : flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n\r\n    img {\r\n        height   : 100px;\r\n        animation: zoom 3s infinite;\r\n    }\r\n\r\n    @keyframes zoom {\r\n\r\n        0%,\r\n        100% {\r\n            transform: scale(1);\r\n            opacity  : 0;\r\n        }\r\n\r\n        50% {\r\n            transform: scale(1.2);\r\n            opacity  : 1;\r\n        }\r\n    }\r\n}\r\n\r\n/*Loader Css Ends*/\r\n/*Auth Css Start*/\r\n.login-main {\r\n    position      : relative;\r\n    z-index       : 1;\r\n    padding-top   : 120px;\r\n    padding-bottom: 120px;\r\n\r\n    &.signup-main {\r\n        padding-top   : 90px;\r\n        padding-bottom: 90px;\r\n    }\r\n\r\n    .loginbg {\r\n        height    : 452px;\r\n        width     : 100%;\r\n        position  : absolute;\r\n        z-index   : -1;\r\n        top       : 0px;\r\n        background: $black-color;\r\n        clip-path : polygon(0 0, 100% 0, 100% 70%, 0% 100%);\r\n\r\n        img {\r\n            height    : 100%;\r\n            width     : 100%;\r\n            object-fit: cover;\r\n            opacity   : 0.41;\r\n        }\r\n    }\r\n\r\n    .loginform {\r\n        background   : $white-color;\r\n        padding      : 70px;\r\n        border-radius: 30px;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            padding: 30px;\r\n        }\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            padding: 20px;\r\n            .btn-primary {\r\n                font-size: 16px !important;\r\n            }\r\n        }\r\n\r\n        .headlogin_div {\r\n            h2 {\r\n                font-size  : 24px;\r\n                color      : $black-color;\r\n                font-weight: 700;\r\n            }\r\n\r\n            p {\r\n                font-size  : 16px;\r\n                color      : $paragraph-color;\r\n                line-height: 1.5;\r\n                max-width  : 320px;\r\n                margin     : 0 auto;\r\n            }\r\n        }\r\n\r\n        .forgotpassword {\r\n            a {\r\n                color          : $black-color;\r\n                font-weight    : 600;\r\n                text-decoration: none;\r\n                font-size      : 16px;\r\n            }\r\n        }\r\n\r\n        .formfooter {\r\n            font-size: 16px;\r\n            color    : $black-color;\r\n\r\n            a {\r\n                color          : $primary-color;\r\n                font-weight    : 700;\r\n                text-decoration: none;\r\n            }\r\n        }\r\n\r\n        .form-group {\r\n         \r\n            .form-label {\r\n                font-size  : 14px;\r\n                font-weight: 500;\r\n                color      : $black-color;\r\n\r\n                span {\r\n                    opacity: 0.30;\r\n                }\r\n            }\r\n       \r\n            .password-input-group {\r\n                svg {\r\n                    position: absolute;\r\n                    top     : 17px;\r\n                    right   : 20px;\r\n                    opacity : 0.8;\r\n                }\r\n            }\r\n            .otpinput{\r\n                // width:65px!important;\r\n                flex: 1;\r\n                height:65px;\r\n                border: 2px solid rgba($black-color, 0.15);\r\n                border-radius: 12px;\r\n                color        : rgba($black-color, 0.70);\r\n                box-shadow: none;\r\n                outline: none;\r\n                &:focus{\r\n                    border: 2px solid $primary-color!important;\r\n                }\r\n                @media only screen and (max-width:500px){\r\n                    // width:55px!important;\r\n                    flex: 1;\r\n                    height:55px;\r\n                }\r\n            }\r\n            .form-control {\r\n                height       : 50px;\r\n                border-radius: 12px;\r\n                border       : 1px solid rgba($black-color, 0.15);\r\n                color        : rgba($black-color, 0.70);\r\n                padding-left : 20px;\r\n                padding-right: 20px;\r\n                font-size    : 14px;\r\n\r\n                &[type=\"password\"] {\r\n                    padding-right: 50px;\r\n                }\r\n\r\n                &:focus {\r\n                    box-shadow: none;\r\n                }\r\n\r\n                &::placeholder {\r\n                    color: $black-color;\r\n                    opacity: 0.50;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.modal-custom{\r\n    &.datamodal{\r\n        .modal-content{\r\n          .modal-header{\r\n            .modal-title{\r\n                font-size: 22px!important;\r\n                font-weight: 400!important;\r\n                b{\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n          }\r\n          .modal-body{\r\n            h6{\r\n                font-weight: 600;\r\n            }\r\n            p{\r\n                margin-bottom: 2px;\r\n            }\r\n          }\r\n        }\r\n    }\r\n    .modal-dialog{\r\n        .modal-content{\r\n            .modal-header{\r\n                 .modal-title{\r\n                    font-size: 24px;\r\n                    color:$black-color;\r\n                    font-weight: bold;\r\n                 }\r\n            }\r\n            .btn-close {\r\n                width              : 28px;\r\n                height             : 28px;\r\n                background-color   : $primary-color;\r\n                border-radius      : 50%;\r\n                padding            : 0 !important;\r\n                background-size    : 10px;\r\n                background-position: center;\r\n                opacity            : 1;\r\n                position           : absolute;\r\n                top                : -7px;\r\n                right              : -7px;\r\n                background-image   : url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\r\n            }\r\n            .modal-body{\r\n                .notesmain{\r\n                    max-height: 370px;\r\n                    overflow-y: auto;\r\n                    &::-webkit-scrollbar {\r\n                        width: 6px;\r\n                      }\r\n                      &::-webkit-scrollbar-thumb {\r\n                        background: #ccc;\r\n                      }\r\n                    .notescont {\r\n                          border: 1px solid rgba($black-color, 0.15);\r\n                          border-radius: 12px;\r\n                          box-shadow: 0 0 10px rgba($black-color, 0.07);\r\n                          color: rgba($black-color, 0.50);\r\n                          display: flex;\r\n                          flex-direction: column;\r\n                          font-size: 13px;          \r\n                          padding: 16px;\r\n                          &:not(:last-child)\r\n                          {\r\n                            margin-bottom: 14px;\r\n                          }\r\n                          h4{\r\n                              color: $black-color;\r\n                              font-size: 14px;\r\n                          }\r\n                          a {\r\n                              color: $black-color;\r\n                              font-size: 14px;\r\n                              min-width: 23px;\r\n                              text-align: end;\r\n                          }\r\n                      }\r\n                }\r\n                .form-control ,  .form-select {\r\n                    height       : auto;\r\n                    border-radius: 12px;\r\n                    border       : 1px solid rgba($black-color, 0.15);\r\n                    color        : $black-color;\r\n                    padding-left : 20px;\r\n                    // padding-top : 10px;\r\n                    min-height: 38px;\r\n                    padding-right: 20px;\r\n                    font-size    : 14px;\r\n                    resize: none;\r\n                    &:focus {\r\n                        box-shadow: none;\r\n                    }\r\n    \r\n                    &::placeholder {\r\n                        color: $black-color;\r\n                        opacity: 0.50;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.reset-success {\r\n    .modal-dialog {\r\n        max-width: 437px;\r\n\r\n        .modal-content {\r\n            border-radius: 30px;\r\n\r\n            .modal-body {\r\n                text-align: center;\r\n                padding   : 40px;\r\n\r\n                h2 {\r\n                    font-size  : 24px;\r\n                    color      : $black-color;\r\n                    font-weight: 700;\r\n                }\r\n\r\n                p {\r\n                    font-size  : 16px;\r\n                    color      : $paragraph-color;\r\n                    font-weight: 400;\r\n                    line-height: 1.5;\r\n                }\r\n\r\n                .btn {\r\n                    min-width: 170px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Auth Css Ends*/\r\n\r\n/*Sidebar Css Start*/\r\n\r\n.sidebar {\r\n    background     : $white-color;\r\n    height         : 100%;\r\n    left           : 0;\r\n    overflow-x     : hidden;\r\n    overflow-y     : auto;\r\n    padding        : 20px;\r\n    position       : fixed;\r\n    scrollbar-color: #e3e3e3 transparent;\r\n    scrollbar-width: thin;\r\n    box-shadow     : 0px 0px 10px rgba($black-color, 0.07);\r\n    top            : 0;\r\n    width          : 270px;\r\n    z-index        : 1031;\r\n\r\n    .sidebarlogo_div {\r\n        text-align    : center;\r\n        border-bottom : 1px solid #e3e3e3;\r\n        padding-bottom: 20px;\r\n        margin-bottom : 20px;\r\n\r\n        img {\r\n            height: 70px;\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 767.98px) {\r\n        &.sidebar-open {\r\n            left      : 0;\r\n            transition: all 1s ease-in-out;\r\n        }\r\n\r\n        &.sidebar-closed {\r\n            left      : -320px;\r\n            transition: all 1s ease-in-out;\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767.98px) {\r\n    button.btnclose {\r\n        background: rgba($black-color, 0.50);\r\n        bottom    : 0;\r\n        left      : 0;\r\n        padding   : 0;\r\n        position  : fixed;\r\n        top       : 0;\r\n        transition: all 1s ease-in-out;\r\n\r\n        &.sidebarbg-open {\r\n            transition: all 1s ease-in-out;\r\n            width     : 100%;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.sidebarouter {\r\n    .submenu{\r\n        .navitem {\r\n            &.submenu-item{\r\n                &::before{\r\n                    display:none\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .navitem {\r\n        padding        : 12px 20px;\r\n        position       : relative;\r\n        color          : $black-color;\r\n        font-size      : 14px;\r\n        text-decoration: none;\r\n        margin-bottom  : 10px;\r\n        display        : flex;\r\n        font-weight    : 500;\r\n\r\n        svg {\r\n            font-size   : 20px;\r\n            margin-right: 10px;\r\n            min-width   : 20px;\r\n        }\r\n\r\n        &:before {\r\n            content      : '';\r\n            position     : absolute;\r\n            top          : 0px;\r\n            left         : -20px;\r\n            height       : 100%;\r\n            background   : $primary-color;\r\n            width        : 0;\r\n            border-radius: 0px 14px 14px 0px;\r\n        }\r\n\r\n        &.active,\r\n        &:hover {\r\n            &:before {\r\n                width: 4px;\r\n            }\r\n\r\n            color        :$white-color;\r\n            background   : $primary-color;\r\n            display      : flex;\r\n            border-radius: 6px;\r\n        }\r\n    }\r\n}\r\n.inactive.active {\r\n    color: #000000;\r\n    background-color:  $primary-color;\r\n}\r\n.badgestatus-more {\r\n    font-size      : 12px;\r\n    border-radius  : 30px;\r\n    min-width      : 62px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n    color          : $white-color;\r\n    padding: 0 9px;\r\n    height: 25px;\r\n    line-height: 25px;\r\n}\r\n@media only screen and (max-width: 767.98px) {\r\n\r\n    .header,\r\n    .maincontent_div {\r\n        margin-left: 0 !important;\r\n    }\r\n\r\n    button.btnclose,\r\n    button.btnopen {\r\n        border : 0 !important;\r\n        display: block !important;\r\n        outline: 0 !important;\r\n        z-index: 101;\r\n    }\r\n\r\n    button.btnopen {\r\n        background: transparent !important;\r\n        box-shadow: none !important;\r\n        left      : 15px;\r\n        position  : absolute;\r\n        top       : 20px;\r\n\r\n        svg {\r\n            font-size: 34px;\r\n        }\r\n    }\r\n}\r\n\r\n/*Sidebar Css Ends*/\r\n/*Header Css Start*/\r\n\r\n.header {\r\n    margin-left: 270px;\r\n    position   : relative;\r\n    z-index    : 1;\r\n    padding    : 10px 15px;\r\n\r\n    .form-switch {\r\n        position: relative;\r\n .form-check-input {\r\n            width              : 49px;\r\n            height             : 25px;\r\n            border             : 1px solid $black-color;\r\n            --bs-form-check-bg : #000;\r\n            --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n\r\n            &:checked {\r\n                background-color: $black-color;\r\n            }\r\n\r\n            &:focus {\r\n                --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n                border             : none;\r\n                outline            : 0;\r\n                box-shadow         : none;\r\n            }\r\n        }\r\n\r\n        svg {\r\n            position : absolute;\r\n            top      : 8px;\r\n            font-size: 18px;\r\n            color    : $white-color;\r\n\r\n            &.light-icon {\r\n                right: 5px;\r\n            }\r\n\r\n            &.dark-icon {\r\n                left: 5px;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .headerright {\r\n        background   : $white-color;\r\n        padding      : 8px 15px;\r\n        border-radius: 50px;\r\n     \r\n        .linksheader {\r\n            svg {\r\n                font-size: 16px;\r\n                color    : $black-color\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            display: inline-flex;\r\n            .dropdown-toggle {\r\n                background: transparent !important;\r\n                border    : none !important;\r\n                span{\r\n                    font-size: 14px;\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    color:$black-color;\r\n                    svg{\r\n                        margin-left: 5px;\r\n                    }\r\n                }\r\n                &::after {\r\n                    display: none;\r\n                }\r\n            }\r\n            .dropdown-item{\r\n                display: inline-flex;\r\n                align-items: center;\r\n                font-size: 14px;\r\n                svg{\r\n                    margin-right: 5px;\r\n                }\r\n                &.active {\r\n                    color: $primary-color;\r\n                    background: transparent;\r\n                }\r\n            }\r\n        }\r\n\r\n        a {\r\n            display: inline-flex;\r\n\r\n            &:hover {\r\n                opacity: 0.75;\r\n                cursor : pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .headerright {\r\n        img {\r\n            width        : 45px;\r\n            height       : 45px;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n/*Header Css Ends*/\r\n/*After Login Css Start*/\r\n.mainbreadcrumb {\r\n    h1 {\r\n        font-size    : 28px;\r\n        color        : $black-color;\r\n        font-weight  : 700;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    nav {\r\n        ol {\r\n            margin-bottom: 5px;\r\n\r\n            li {\r\n                a {\r\n                    color          : $black-color;\r\n                    font-size      : 14px;\r\n                    font-weight    : 500;\r\n                    text-decoration: none;                  \r\n                }\r\n                &.active{\r\n                    &:before{\r\n                        color:rgba($white-color,0.50)\r\n                       }\r\n                       color:rgba($white-color,0.50)\r\n                   }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.min-width-159 {\r\n    min-width: 159px;\r\n}\r\n.min-max-width-159 {\r\n    min-width: 159px;\r\n    max-width: 159px;\r\n}\r\n.min-width-147 {\r\n    min-width: 147px;\r\n}\r\n\r\n.wrapper {\r\n    background: #F6F6F6 !important;\r\n    min-height: 100vh;\r\n\r\n    .maincontent_div {\r\n        -webkit-backface-visibility: hidden;\r\n        backface-visibility        : hidden;\r\n        margin-left                : 270px;\r\n        padding                    : 15px;\r\n        position                   : relative;\r\n        transition                 : all .3s ease;\r\n\r\n        .stats {\r\n            background   : $white-color;\r\n            border-radius: 10px;\r\n            box-shadow   : 0 0 10px rgba($black-color, 0.07);\r\n            min-height   : 110px;\r\n            padding      : 20px;\r\n\r\n            h4 {\r\n                font-size  : 14px;\r\n                color      : rgba($black-color, 0.50);\r\n                font-weight: 400;\r\n                margin     : 0;\r\n            }\r\n\r\n            p {\r\n                font-size  : 22px;\r\n                color      : $black-color;\r\n                font-weight: bold;\r\n                margin     : 0;\r\n            }\r\n\r\n            .statsicon {\r\n                background     : rgba(#5ECFFF, 0.10);\r\n                border-radius  : 12px;\r\n                height         : 65px;\r\n                width          : 65px;\r\n                min-width      : 65px;\r\n                display        : flex;\r\n                align-items    : center;\r\n                justify-content: center;\r\n                margin-right   : 15px;\r\n\r\n                img {\r\n                    height    : 29px;\r\n                    object-fit: contain;\r\n                }\r\n\r\n                &.statsdarkpurple {\r\n                    background: rgba(#6418C3, 0.10);\r\n\r\n                    svg {\r\n                        color: #6418C3;\r\n                    }\r\n                }\r\n\r\n                &.statsred {\r\n                    background: rgba($danger-color, 0.10);\r\n\r\n                    svg {\r\n                        color: $danger-color\r\n                    }\r\n                }\r\n\r\n                &.statspurple {\r\n                    background: rgba($purple-color, 0.10);\r\n\r\n                    svg {\r\n                        color: $purple-color\r\n                    }\r\n                }\r\n\r\n                &.statsgreen {\r\n                    background: rgba(#01943C, 0.10);\r\n\r\n                    svg {\r\n                        color: #01943C\r\n                    }\r\n                }\r\n\r\n                &.statsdarkgreen {\r\n                    background: rgba($green-color, 0.10);\r\n\r\n                    svg {\r\n                        color: $green-color\r\n                    }\r\n                }\r\n\r\n                &.statsdarkblue {\r\n                    background: rgba($secondary-color, 0.10);\r\n\r\n                    svg {\r\n                        color: $secondary-color\r\n                    }\r\n                }\r\n\r\n                svg {\r\n                    color    : #5ECFFF;\r\n                    font-size: 29px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .recharts-wrapper {\r\n            .recharts-legend-wrapper {\r\n                background   : $white-color;\r\n                padding      : 10px 15px;\r\n                border       : 1px solid rgba($black-color, 0.10);\r\n                border-radius: 12px;\r\n                box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    display: none;\r\n                }\r\n\r\n                .recharts-default-legend {\r\n                    li {\r\n                        &.recharts-legend-item {\r\n                            opacity: 0.50;\r\n\r\n                            .recharts-legend-item-text {\r\n                                color    : $black-color !important;\r\n                                font-size: 12px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .recharts-default-tooltip {\r\n                .recharts-tooltip-label {\r\n                    color      : $black-color !important;\r\n                    font-weight: bold;\r\n                }\r\n\r\n                .recharts-tooltip-item-list {\r\n                    li {\r\n                        font-size: 12px;\r\n                        color    : $black-color !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n\r\n        .card {\r\n            --bs-border-radius: 12px !important;\r\n            border            : none !important;\r\n            box-shadow        : 0 0 10px rgba($black-color, 0.12);\r\n\r\n            .card-header {\r\n                background    : $white-color;\r\n                padding-bottom: 12px;\r\n                padding-top   : 12px;\r\n\r\n                h5 {\r\n                    font-size    : 20px;\r\n                    font-weight  : 600;\r\n                    margin-bottom: 0;\r\n                    color        : $black-color;\r\n                }\r\n                .OrderCount_Date {\r\n                    font-size: 14px;\r\n                    font-weight: 500;\r\n                    color: $black-color;\r\n                    margin: 0px 10px;\r\n                }\r\n                .btnaccept , .btnreject{\r\n                    font-size: 14px;\r\n                    font-weight: 500;\r\n                    text-decoration: none;\r\n                    padding: 0px 15px;\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    border-radius: 30px;\r\n                    svg{\r\n                        font-size: 18px;\r\n                        margin-right: 5px;\r\n                    }\r\n                }\r\n                .btnaccept{\r\n                    color:$primary-color;\r\n                    border: 1px solid $primary-color;\r\n                    &:hover{\r\n                        background: $primary-color;\r\n                        color:$white-color\r\n                    }\r\n                }\r\n                .btnreject{ \r\n                    color:$danger-color;\r\n                    border: 1px solid $danger-color;\r\n                    &:hover{\r\n                        background: $danger-color;\r\n                        color:$white-color\r\n                    }\r\n                }\r\n            }\r\n\r\n            .card-body {\r\n                .btnnote {\r\n                    align-items: center;\r\n                    border: 1px solid $black-color;\r\n                    border-radius: 50px;\r\n                    color: $black-color;\r\n                    display: inline-flex;\r\n                    font-size: 13px;\r\n                    font-weight: 500;\r\n                    height: 32px;\r\n                    justify-content: center;\r\n                    min-width: 110px;\r\n                    text-decoration: none;\r\n                    &:hover{\r\n                        background:$black-color;\r\n                        color: $white-color;\r\n                    }\r\n                }\r\n                .customtabs {\r\n                    &.nav-tabs {\r\n                        border: none;\r\n\r\n                        li {\r\n                            &.nav-item {\r\n                                button {\r\n                                    &.nav-link {\r\n                                        border       : 1px solid rgba($secondary-color, 0.10);\r\n                                        border-radius: 40px;\r\n                                        color        : $secondary-color;\r\n                                        font-weight  : 500;\r\n                                        padding      : 10px 20px;\r\n                                        font-size    : 15px;\r\n                                        margin       : 0px 5px 10px 0px;\r\n                                        background   : rgba($secondary-color, 0.10);\r\n                                        min-width    : 170px;\r\n\r\n                                        &.active,\r\n                                        &:hover {\r\n                                            background: $secondary-color;\r\n                                            color     : $white-color\r\n                                        }\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                  .searchfield{\r\n                    svg{\r\n                        font-size: 18px;\r\n                        left: 15px;\r\n                        min-width: 18px;\r\n                        opacity: .5;\r\n                        position: absolute;\r\n                        top: 15px;\r\n                    }\r\n                    .form-control{\r\n                        padding-left: 42px!important;\r\n                    }\r\n                  }\r\n                  .btnedit {\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    border: 1px solid $secondary-color;\r\n                    color:$secondary-color;\r\n                    border-radius: 50%;\r\n                    &:hover{\r\n                        background: $secondary-color;\r\n                        color:$white-color;\r\n                    }\r\n                }\r\n                .workorders{\r\n                    text-decoration: none;\r\n                    color:rgba($black-color, .70);\r\n                    &:hover{\r\n                        color:$primary-color;\r\n                    }\r\n                }\r\n                .orders-card{\r\n                    background: $white-color;\r\n                    border: 1px solid rgba($black-color, 0.1);\r\n                    border-radius: 12px;\r\n                    box-shadow: 0px 0px 10px rgba($black-color, 0.07);\r\n                    padding: 20px;\r\n                    height: 100%;\r\n                    label{\r\n                        font-size: 14px;\r\n                        color: $black-color;\r\n                        font-weight: 500;\r\n                        min-width: 100px;\r\n                        margin-right: 10px;\r\n                    }\r\n                    span{\r\n                        font-size: 14px;\r\n                        color:$black-color;\r\n                        font-weight: 300;\r\n                    }\r\n                    h4{\r\n                        color:$black-color;\r\n                        font-size: 16px;\r\n                        font-weight: 600;\r\n                        margin-bottom: 10px;\r\n                    }\r\n                    p{\r\n                        font-size: 14px;\r\n                        color:$black-color;\r\n                        margin-bottom:10px;\r\n                    }\r\n                } \r\n                .btnaccept , .btnreject{\r\n                    font-size: 14px;\r\n                    font-weight: 500;\r\n                    text-decoration: none;\r\n                    height: 30px;                  \r\n                    padding: 0px 10px;\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    border-radius: 30px;\r\n                    svg{\r\n                        font-size: 18px;\r\n                        margin-right: 5px;\r\n                    }\r\n                }\r\n                .btnaccept{\r\n                    color:$primary-color;\r\n                    border: 1px solid $primary-color;\r\n                    &:hover{\r\n                        background: $primary-color;\r\n                        color:$white-color\r\n                    }\r\n                }\r\n                .btnreject{ \r\n                    color:$danger-color;\r\n                    border: 1px solid $danger-color;\r\n                    &:hover{\r\n                        background: $danger-color;\r\n                        color:$white-color\r\n                    }\r\n                }\r\n                .statusnew {\r\n                    font-size      : 12px;\r\n                    border-radius  : 30px;\r\n                    min-width      : 62px;\r\n                    display        : inline-flex;\r\n                    align-items    : center;\r\n                    justify-content: center;\r\n                    color          : #01943C!important;\r\n                    background: rgba(#01943C, 0.10);\r\n                    padding: 0 9px;\r\n                    height: 25px;\r\n                    line-height: 25px;\r\n                    text-transform: capitalize;\r\n                }\r\n                .statuscancle {\r\n                    font-size      : 12px;\r\n                    border-radius  : 30px;\r\n                    min-width      : 62px;\r\n                    display        : inline-flex;\r\n                    align-items    : center;\r\n                    justify-content: center;\r\n                    color          : red!important;\r\n                    background: rgba(rgb(255, 0, 0), 0.10);\r\n                    padding: 0 9px;\r\n                    height: 25px;\r\n                    line-height: 25px;\r\n                    text-transform: capitalize;\r\n                }\r\n                .download-wo-allfiles{\r\n                    border: 1px dashed rgba($black-color, 0.1);\r\n                    border-radius: 12px;\r\n                    box-shadow: 0px 0px 10px rgba($black-color, 0.07);\r\n                    padding: 15px;\r\n                    svg{\r\n                        font-size: 32px;\r\n                        color:$black-color;\r\n                        margin-bottom: 5px;\r\n                    }\r\n                    p{\r\n                        font-size: 12px;\r\n                        color:$black-color;\r\n                        text-align: center;\r\n                    }\r\n                }\r\n                .badgestatus {\r\n                    font-size      : 12px;\r\n                    border-radius  : 30px;\r\n                    min-width      : 62px;\r\n                    display        : inline-flex;\r\n                    align-items    : center;\r\n                    justify-content: center;\r\n                    color          : $white-color;\r\n                    padding: 0 9px;\r\n                    height: 25px;\r\n                    line-height: 25px;\r\n                }\r\n                .orders-shipping{\r\n                    border:1px solid rgba($black-color, .1);\r\n                    padding: 18px 15px;\r\n                    border-radius: 12px;\r\n                    color:rgba($black-color, .70);\r\n                    box-shadow: 0px 0px 10px rgba($black-color, 0.1);\r\n                    b{\r\n                        font-weight: 500;\r\n                    }\r\n                }\r\n                .orders-detail{\r\n                    border:1px solid rgba($black-color, .1);\r\n                    padding: 18px 15px;\r\n                    border-radius: 12px;\r\n                    color:rgba($black-color, .70);\r\n                    box-shadow: 0px 0px 10px rgba($black-color, 0.1);\r\n                    overflow-x: auto;\r\n                    &::-webkit-scrollbar {\r\n                        height: 5px;\r\n                    }\r\n        \r\n                    &::-webkit-scrollbar-thumb {\r\n                        background: #c5c4c4;\r\n                    }\r\n                    .form-check-input {\r\n                        width: 22px;\r\n                        height: 22px;\r\n                        border-color: rgba($black-color, 0.3);\r\n                        box-shadow: none;\r\n                        &:checked{\r\n                            background-color: $black-color;\r\n                            border-color: $black-color;\r\n                        }\r\n                    }\r\n                }\r\n                .list-main {\r\n                    .w-40{\r\n                        width: 40%;\r\n                        @media only screen and (max-width:1299.98px) {\r\n                            width: initial;\r\n                        }\r\n                    }\r\n                    .w-20{\r\n                        width: 20%;\r\n                        @media only screen and (max-width:1299.98px) {\r\n                            width: initial;\r\n                        }\r\n                    }\r\n                    .list-qty{\r\n                        .qty{\r\n                            height: 25px;\r\n                            background: rgba($black-color, .03);\r\n                            border: 1px solid rgba($black-color, .1);\r\n                            border-radius: 6px;\r\n                            font-size: 12px;\r\n                            display: inline-flex;\r\n                            align-items: center;\r\n                            padding: 0px 10px;\r\n                            color:$black-color;\r\n                            strong{\r\n                                font-weight: 500;\r\n                            }\r\n                        }\r\n                        .price-total{\r\n                            font-size: 14px;\r\n                            color:rgba($black-color, .60)\r\n                        }\r\n                    }\r\n                    .list-left{\r\n                        .list-img-outer{\r\n                            text-align: center;\r\n                            width: 160px;\r\n                            min-width: 160px;\r\n                            .list-img{\r\n                                width: 160px;\r\n                                min-width: 160px;\r\n                                height: 160px;\r\n                                border-radius: 12px;\r\n                                box-shadow: 0px 0px 10px rgba($black-color, 0.10);\r\n                                // overflow: hidden;\r\n                                display: inline-flex;\r\n                                align-items: center;\r\n                                justify-content: center;\r\n                                position: relative;\r\n                                .bublenumber {\r\n                                    position: absolute;\r\n                                    top: -10px;\r\n                                    left: -10px;\r\n                                    background: #98c1eb;\r\n                                    display: inline-block;\r\n                                    border-radius: 10px;\r\n                                    font-size: 12px;\r\n                                    font-weight: 400;\r\n                                    color: #000;\r\n                                    padding: 2px 7px;\r\n                                }\r\n                                img{\r\n                                   object-fit: scale-down;\r\n                                   padding: 10px;\r\n                                }\r\n                            }\r\n                            span{\r\n                              font-size: 12px;\r\n                              color:rgba($black-color, 0.60);\r\n                            }\r\n                        }\r\n                        .list-content{\r\n                            padding-left: 15px;\r\n                            h2{\r\n                               font-size: 14px;\r\n                               color:$black-color;\r\n                               font-weight: 500;  \r\n                               margin-bottom: 3px;\r\n                               max-width: 200px;\r\n                               svg{\r\n                                font-size: 26px;\r\n                               }\r\n                            }\r\n                          \r\n                        }\r\n                    }\r\n                    .list-checkboxes{\r\n                        .CuttingCheck_div {\r\n                            p {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                gap: 5px;\r\n                                .custom-label-tag {\r\n                                    margin-bottom: 0px;\r\n                                }\r\n                            }                            \r\n                        }\r\n                        .postOpsCheckbox_div {\r\n                            .postOpsCheckbox_box {\r\n                                gap: 5px;\r\n                                margin-bottom: 10px;\r\n                                span {\r\n                                    background: #ff8cd3;\r\n                                    color: #000;\r\n                                    font-size: 14px;\r\n                                    font-weight: 600;\r\n                                    padding: 8px 12px;\r\n                                    line-height: normal;\r\n                                    border-radius: 10px;\r\n                                    display: inline-block;\r\n                                }\r\n                            }\r\n                        }\r\n                        .custom-label{\r\n                            height: 25px;\r\n                            padding: 0px 10px;\r\n                            font-size: 12px;\r\n                            color:$white-color;\r\n                            display: inline-flex;\r\n                            align-items: center;\r\n                            line-height: 25px;\r\n                            border-radius: 30px;\r\n                            margin-bottom: 7px;\r\n                            white-space: nowrap;\r\n                        }\r\n                    }\r\n                    .list-attachment{\r\n                        img{\r\n                            height: 32px;\r\n                            object-fit: contain;\r\n                        }\r\n                        span{\r\n                            font-size: 12px;\r\n                            color:$black-color;\r\n                            margin-top: 5px;\r\n                        }\r\n                    }\r\n                    &:not(:last-child){\r\n                        border-bottom: 1px solid rgba($black-color, .1);\r\n                        padding-bottom: 15px;\r\n                        margin-bottom: 20px;\r\n                    }\r\n                }\r\n                .table {\r\n                    &.tablecustom {\r\n                        border-collapse: initial;\r\n                        border-spacing : 0 .75em;\r\n                        margin-bottom  : 0;\r\n                        padding        : 5px;\r\n                        tbody {\r\n                            tr {\r\n                                box-shadow   : 0px 0px 10px rgba($black-color, .1);\r\n                                border-radius: 12px;\r\n      \r\n                               \r\n                                .form-check-input {\r\n                                    width : 22px;\r\n                                    height: 22px;\r\n                                    border-color:rgba($black-color, .30);\r\n                                    box-shadow: none;\r\n                                    &:checked {\r\n                                        background-color: $primary-color;\r\n                                        border-color    : $primary-color;\r\n                                    }\r\n                                }\r\n\r\n                                td {\r\n                                    b {\r\n                                        font-weight : 500;\r\n                                        margin-right: 5px;\r\n                                    }\r\n\r\n                                    &:first-child {\r\n                                        border-left  : 1px solid rgba($black-color, .1);\r\n                                        border-radius: 12px 0 0 12px;\r\n                                    }\r\n\r\n                                    &:last-child {\r\n                                        border-radius: 0 12px 12px 0;\r\n                                        border-right : 1px solid rgba($black-color, .1);\r\n\r\n                                        button {\r\n                                            svg {\r\n                                                font-size: 22px;\r\n                                                color    : $black-color\r\n                                            }\r\n                                        }\r\n                                    }\r\n\r\n                                    border         : 1px solid rgba($black-color, .1);\r\n                                    border-left    : none;\r\n                                    border-right   : none;\r\n                                    color          : rgba($black-color, .70);\r\n                                    font-size      : 14px;\r\n                                    font-weight    : 400;\r\n                                    height         :60px;\r\n                                    padding        : 15px 15px;\r\n                                    vertical-align : middle;\r\n\r\n                                    @media only screen and (max-width:1199.98px) {\r\n                                        font-size: 12px;\r\n                                    }\r\n                                }\r\n                                .expanded-top{\r\n                                    .checkbox-top{\r\n                                        .form-check{\r\n                                            padding-left: 0;\r\n                                            padding-right: 1.5em;\r\n                                            display: inline-flex;\r\n                                            align-items: center;\r\n                                            flex-direction: row-reverse;\r\n                                            .form-check-input {\r\n                                                margin: 0\r\n                                            }\r\n                                            .form-check-label{\r\n                                              font-size: 16px;\r\n                                              color:$black-color;\r\n                                              margin-right: 10px;\r\n                                            }\r\n                                        }\r\n                                    }\r\n                                    .workorders {\r\n                                        font-size: 18px;\r\n                                        color:$black-color;\r\n                                        font-weight: 600;\r\n                                        margin-top: 10px;\r\n                                    }\r\n                                    .upload-download{\r\n                                        display: flex;\r\n                                        align-items: center;\r\n                                        flex-direction: column;\r\n                                        border:1px dashed rgba($black-color, .1);\r\n                                        padding: 10px;\r\n                                        border-radius: 8px;\r\n                                        svg{\r\n                                            font-size: 32px;\r\n                                            color:$black-color;\r\n                                            margin-bottom: 5px;\r\n                                        }\r\n                                        span{\r\n                                            font-size: 12px;\r\n                                            color:$black-color;\r\n                                            white-space: nowrap;\r\n                                        }\r\n                                    }\r\n                                }\r\n                               \r\n                                &.expanded-row{\r\n                                        td{\r\n                                            border-top: 1px solid $primary-color;\r\n                                            border-bottom: 1px solid $primary-color;\r\n                                            &:first-child{\r\n                                              border-left: 1px solid $primary-color;\r\n                                            }\r\n                                            &:last-child{\r\n                                              border-right: 1px solid $primary-color;\r\n                                            }\r\n                                        }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .form-group {\r\n                    .form-label {\r\n                        font-size    : 14px;\r\n                        font-weight  : 500;\r\n                        color        : $black-color;\r\n                        margin-bottom: 4px;\r\n                    }\r\n                    .form-check{\r\n                        &.form-switch{\r\n                            .form-check-input{\r\n                                &:checked{\r\n\r\n                                    background-color: $primary-color;\r\n                                    border-color: $primary-color;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                    .quill {\r\n                        .ql-toolbar{\r\n                            &.ql-snow{\r\n                                border: 1px solid rgba($black-color, 0.15);\r\n                                border-radius:12px 12px 0px 0px\r\n                            }\r\n                        }\r\n                        .ql-container{\r\n                            &.ql-snow{\r\n                                border: 1px solid rgba($black-color, 0.15);\r\n                                border-top:0;\r\n                                border-radius: 0px 0px 12px 12px\r\n                            }\r\n                        }\r\n                    }\r\n                    .password-input-group {\r\n                        svg {\r\n                            position: absolute;\r\n                            top     : 17px;\r\n                            right   : 20px;\r\n                            opacity : 0.30;\r\n                        }\r\n                    }\r\n\r\n                    .form-control , .form-select {\r\n                        height       : 50px;\r\n                        border-radius: 12px;\r\n                        border       : 1px solid rgba($black-color, 0.15);\r\n                        color        : rgba($black-color, 0.70);\r\n                        padding-left : 20px;\r\n                        padding-right: 20px;\r\n                        font-size    : 14px;\r\n\r\n                        &[type=\"password\"] {\r\n                            padding-right: 50px;\r\n                        }\r\n\r\n                        &:focus {\r\n                            box-shadow: none;\r\n                        }\r\n\r\n                        &::placeholder {\r\n                            color: $black-color;\r\n                            opacity: 0.50;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .profileuser {\r\n                    border       : 1px solid rgba($black-color, 0.10);\r\n                    border-radius: 15px;\r\n                    box-shadow   : 0px 0px 10px rgba($black-color, 0.10);\r\n                    padding      : 30px 20px;\r\n\r\n                    .userinfo {\r\n                        width        : 124px;\r\n                        height       : 124px;\r\n                        border       : 5px solid $white-color;\r\n                        border-radius: 50%;\r\n                        box-shadow   : 0px 0px 10px rgba($black-color, 0.20);\r\n                        position     : relative;\r\n                        margin-bottom: 20px;\r\n\r\n                        img {\r\n                            width        : 100%;\r\n                            height       : 100%;\r\n                            border-radius: 50%;\r\n                            object-fit   : cover;\r\n                        }\r\n\r\n                        label {\r\n                            width          : 34px;\r\n                            height         : 34px;\r\n                            background     : $secondary-color;\r\n                            display        : inline-flex;\r\n                            align-items    : center;\r\n                            justify-content: center;\r\n                            border-radius  : 50%;\r\n                            position       : absolute;\r\n                            bottom         : 0px;\r\n                            right          : 0px;\r\n                            margin-bottom  : 0;\r\n                            cursor         : pointer;\r\n\r\n                            svg {\r\n                                color: $white-color\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    h4 {\r\n                        font-size    : 20px;\r\n                        color        : $black-color;\r\n                        font-weight  : 600;\r\n                        margin-bottom: 5px;\r\n                    }\r\n\r\n                    p {\r\n                        font-size    : 16px;\r\n                        color        : $paragraph-color;\r\n                        margin-bottom: 0;\r\n                    }\r\n                }\r\n\r\n                .payment-card {\r\n                    background   : $white-color;\r\n                    border       : 1px solid rgba($black-color, 0.10);\r\n                    border-radius: 12px;\r\n                    box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n                    padding      : 20px;\r\n\r\n                    label {\r\n                        font-size   : 14px;\r\n                        color       : $black-color;\r\n                        font-weight : 500;\r\n                        min-width   : 105px;\r\n                        margin-right: 10px;\r\n                    }\r\n\r\n                    span {\r\n                        font-size  : 14px;\r\n                        color      : $black-color;\r\n                        font-weight: 300;\r\n                        line-height: normal;\r\n\r\n                        &.statusactive {\r\n                            height       : 25px;\r\n                            background   : rgba(#01943C, 0.10);\r\n                            color        : #01943C;\r\n                            padding      : 0px 15px;\r\n                            line-height  : 25px;\r\n                            border-radius: 50px;\r\n                            font-weight  : 500;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .viewpaymentdetail {\r\n                    p {\r\n                        display        : flex;\r\n                        justify-content: space-between;\r\n                        font-size      : 16px;\r\n                        color          : $black-color;\r\n                    }\r\n\r\n                }\r\n\r\n                .btnview , .btndelete {\r\n                    align-items    : center;\r\n                    border-radius  : 50%;\r\n                    color          : $white-color;\r\n                    display        : inline-flex;\r\n                    font-size      : 18px;\r\n                    height         : 35px;\r\n                    justify-content: center;\r\n                    margin         : 0 3px;\r\n                    min-width      : 35px;\r\n                    width          : 35px;\r\n                  \r\n\r\n                    &:hover {\r\n                        opacity: 0.75;\r\n                    }\r\n                }\r\n .btnview{\r\n    background     : $primary-color;\r\n }\r\n .btndelete{\r\n    background     : $danger-color;\r\n }\r\n                .files-image {\r\n                    background     : $white-color;\r\n                    box-shadow     : 0px 0px 10px rgba($black-color, 0.10);\r\n                    border-radius  : 4px;\r\n                    width          : 50px;\r\n                    min-width      : 50px;\r\n                    height         : 50px;\r\n                    display        : flex;\r\n                    align-items    : center;\r\n                    justify-content: center;\r\n\r\n                    img {\r\n                        height: 41px;\r\n                    }\r\n                }\r\n                 .table-responsive{\r\n                    &::-webkit-scrollbar {\r\n                        height: 5px;\r\n                    }\r\n        \r\n                    &::-webkit-scrollbar-thumb {\r\n                        background: #c5c4c4;\r\n                    }\r\n                 }\r\n                .custom-table {\r\n                    // scrollbar-width: thin;\r\n                    // scrollbar-color: #ccc transparent;\r\n\r\n                    &::-webkit-scrollbar {\r\n                        height: 5px;\r\n                    }\r\n        \r\n                    &::-webkit-scrollbar-thumb {\r\n                        background: #c5c4c4;\r\n                    }\r\n                \r\n                    .rdt_TableHead {\r\n                        .rdt_TableHeadRow {\r\n                            background    : #FAFAFA;\r\n                            border-radius : 12px;\r\n                            margin        : 5px 0;\r\n                            padding-top   : 15px;\r\n                            padding-bottom: 15px;\r\n                            min-height    : 60px;\r\n                            border        : 1px solid rgba($black-color, 0.10);\r\n\r\n                            .rdt_TableCol {\r\n                                color      : $black-color;\r\n                                font-size  : 14px;\r\n                                font-weight: 600;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .rdt_TableBody {\r\n                        .rdt_TableRow {\r\n                            .rdt_TableCell {\r\n                                padding-top   : 10px;\r\n                                padding-bottom: 10px;\r\n                                color         : rgba($black-color, 0.70);\r\n                                font-size     : 14px;\r\n\r\n                                &>div {\r\n                                    white-space: pre-wrap\r\n                                }\r\n                            }\r\n\r\n                            min-height   : 60px;\r\n                            border-radius: 12px;\r\n                            background   : $white-color;\r\n                            border       :1px solid rgba($black-color, 0.10);\r\n                            margin       : 5px 0;\r\n                        }\r\n                    }\r\n                }\r\n                .ShippingPackageOrder_info {\r\n                    align-items: center;\r\n                    margin-bottom: 10px;\r\n                    .gap_10 {\r\n                        gap: 10px;\r\n                        flex-wrap: wrap;\r\n                    }\r\n                    p {\r\n                        border-radius: 5px;\r\n                        padding: 10px 20px;\r\n                        background: $white-color;\r\n                        display: inline-block;\r\n                        border: 1px solid rgba(0, 0, 0, 0.1);\r\n                        font-size: 14px; \r\n                        margin: 0px;                         \r\n                    }\r\n                    .downloadLabel_btn {\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background: #4e8ac8;\r\n                        color: #000;\r\n                        font-size: 14px;\r\n                        font-weight: 700;\r\n                        padding: 10px 20px;\r\n                        border-radius: 10px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        text-decoration: none;\r\n                        height: 42px;\r\n                    }\r\n                    .RefundLabel_btn {\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background: #ff8282;\r\n                        color: #000;\r\n                        font-size: 14px;\r\n                        font-weight: 700;\r\n                        padding: 10px 20px;\r\n                        border-radius: 10px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        text-decoration: none;\r\n                        height: 42px;\r\n                    }\r\n                }\r\n                .PackagePurchase_btn {\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    background: #4e8ac8;\r\n                    color: #000;\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                    padding: 10px 20px;\r\n                    border-radius: 10px;\r\n                    outline: 0px;\r\n                    box-shadow: none;\r\n                    height: 42px;\r\n                }\r\n                .PackageCompleteOrder_btn {\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    background: #a6c3e2;\r\n                    color: #000;\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                    padding: 10px 20px;\r\n                    border-radius: 10px;\r\n                    outline: 0px;\r\n                    box-shadow: none;\r\n                    height: 42px;\r\n                }\r\n                .PackageAddAnother_btn {\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    background: #00bf63;\r\n                    color: #000;\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                    padding: 10px 20px;\r\n                    border-radius: 10px;\r\n                    outline: 0px;\r\n                    box-shadow: none;\r\n                    height: 42px;\r\n                }\r\n                .PackageRemove_btn {\r\n                    display: inline-flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    background: #fff;\r\n                    color: #ca0000;\r\n                    border: 1px solid #ca0000;\r\n                    font-size: 22px;\r\n                    padding: 10px 12px;\r\n                    border-radius: 10px;\r\n                    outline: 0px;\r\n                    box-shadow: none;\r\n                }\r\n                .dimensionShow_div {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 30px;\r\n                    .RefundLabel_btn {\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background: #ff8282;\r\n                        color: #000;\r\n                        font-size: 14px;\r\n                        font-weight: 700;\r\n                        padding: 10px 20px;\r\n                        border-radius: 10px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        text-decoration: none;\r\n                        border: none;\r\n                        height: 42px;\r\n                    }\r\n                    .dimensionShowCheckbox_div {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        margin: 5px 0px;\r\n                        input[type=\"checkbox\"] {\r\n                            -webkit-appearance: none;\r\n                            -moz-appearance: none;\r\n                            // appearance: none;\r\n                            margin-right: 5px;\r\n                            width: 20px;\r\n                            height: 20px;\r\n                            border: 1px solid rgba($black-color, .60);\r\n                            background-color: #fff;\r\n                            border-radius: 4px;\r\n                            &:checked {\r\n                                background-color: rgba($black-color, .60); /* Light gray */\r\n                                border-color: rgba($black-color, .60);\r\n                                background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e\");\r\n                              }\r\n                          }\r\n                        label {\r\n                            font-size: 16px;\r\n                        }\r\n                    }\r\n                }\r\n                .packageDeminsionMain_div {\r\n                    .ShippingMethodmain_title {\r\n                        font-size: 18px;\r\n                        font-weight: 700;\r\n                        color: $black-color;\r\n                        margin-bottom: 10px;\r\n                    }\r\n                    .gap_20 {\r\n                        gap: 40px;\r\n                    }\r\n                    .getRate_btn {\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background: #4e8ac8;\r\n                        color: #000;\r\n                        font-size: 14px;\r\n                        font-weight: 700;\r\n                        padding: 10px 20px;\r\n                        border-radius: 10px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        height: 42px;\r\n                    }\r\n                    .DeminsionMain_div {\r\n                        .PachageField_div {\r\n                            .PachageField_label {\r\n                                font-size: 16px;\r\n                                font-weight: 600;\r\n                                margin-bottom: 5px;\r\n                                line-height: normal;\r\n                                color: #000;\r\n                            }\r\n                            .PackageFieldSubtitle {\r\n                                font-size: 14px;\r\n                                font-weight: 500;\r\n                                margin-top: 5px;\r\n                                line-height: normal;\r\n                                color: #000;\r\n                            }\r\n                            .DeminsionField_flex {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                gap: 10px;\r\n                                font-size: 14px;\r\n                                color: $black-color;\r\n                                .PachageField_box {\r\n                                    position: relative;\r\n                                    width: 100%;\r\n                                    input.PachageField_number {\r\n                                        height: 42px;\r\n                                        border-radius: 5px;\r\n                                        padding: 4px 10px 4px 30px;\r\n                                        text-align: right;\r\n                                        background: $white-color;\r\n                                        box-sizing: border-box;\r\n                                        display: inline-block;\r\n                                        outline: 0px;\r\n                                        border: 1px solid rgba(0, 0, 0, 0.1);\r\n                                        font-size: 14px;  \r\n                                        box-sizing: border-box;\r\n                                        width: 100%;\r\n                                        &::-webkit-inner-spin-button {\r\n                                            -webkit-appearance: none;\r\n                                            margin: 0;\r\n                                        }\r\n                                    }\r\n                                    .PachageField_Size {\r\n                                        position: absolute;\r\n                                        top: 6px;\r\n                                        bottom: 6px;\r\n                                        left: 6px;\r\n                                        display: inline-flex;\r\n                                        align-items: center;\r\n                                        justify-content: center;\r\n                                        background: #f0f0f0;\r\n                                        color: $black-color;\r\n                                        font-size: 14px;\r\n                                        padding: 2px 5px;\r\n                                    }                                    \r\n                                }\r\n                                \r\n                                .PachageFieldSizeSelect {\r\n                                    height: 42px;\r\n                                    border-radius: 5px;\r\n                                    padding: 4px 10px;\r\n                                    text-align: left;\r\n                                    background-color: $white-color;\r\n                                    box-sizing: border-box;\r\n                                    display: inline-block;\r\n                                    outline: 0px;\r\n                                    border: 1px solid rgba(0, 0, 0, 0.1);\r\n                                    font-size: 14px;  \r\n                                    box-sizing: border-box;\r\n                                    width: 100%;\r\n                                }\r\n                                &.max_250 {\r\n                                    width: 100%;\r\n                                    max-width: 250px;\r\n                                    margin: 0px;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.custom-label-tag{\r\n    height: 25px;\r\n    padding: 0px 10px;\r\n    font-size: 12px;\r\n    color:$white-color;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    line-height: 25px;\r\n    border-radius: 30px;\r\n    margin-bottom: 7px;\r\n    white-space: nowrap;\r\n}\r\n@media only screen and (max-width: 767.98px) {\r\n\r\n    .header,\r\n    .maincontent_div {\r\n        margin-left: 0 !important;\r\n    }\r\n}\r\n\r\n/*After Login Css Ends*/\r\n.sortByMain_box {\r\n    display: flex;\r\n    gap: 0px 20px;\r\n    margin-bottom: 10px;\r\n    .sortByMain_head {\r\n        display: inline-flex;\r\n        align-items: flex-start;\r\n        min-width: 120px;\r\n        justify-content: flex-end;\r\n        margin-right: 10px;\r\n        flex-shrink: 0;\r\n        .sortByHead_box {\r\n            display: inline-flex;\r\n            background: #d9d9d9;\r\n            color: $black-color;\r\n            padding: 8px 10px;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            border-radius: 10px;\r\n        }\r\n        .sortByFilterBtn {\r\n            position: relative;\r\n            font-size: 18px;\r\n            color: $black-color;\r\n            display: inline-flex;\r\n            .sortFilterClose {\r\n                position: absolute;\r\n                font-size: 14px;\r\n                border: 1px solid #fff;\r\n                border-radius: 50%;\r\n                bottom: 0px;\r\n                right: -6px;\r\n            }\r\n        }\r\n    }\r\n    .SortFilterBtnBox {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        gap: 10px;\r\n        flex-grow: 1;\r\n        .SortFilter_btn {\r\n            display: inline-flex;\r\n            background: #d9d9d9;\r\n            color: $black-color;\r\n            padding: 10px 12px;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            border-radius: 10px;\r\n            text-transform: uppercase;\r\n            border: 0px;\r\n            line-height: normal;\r\n            &.active {\r\n                background: #ff8cd3;\r\n            }\r\n            &:hover {\r\n                background: #ff8cd3;\r\n            }\r\n        }\r\n    }\r\n    .tagFilterBtnBox {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        gap: 10px;\r\n        flex-grow: 1;\r\n        .tagFilter_btn {\r\n            // Base button styling (series colors inherited from global unified post ops styles)\r\n            display: inline-flex;\r\n            padding: 10px 12px;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            border-radius: 10px;\r\n            text-transform: uppercase;\r\n            border: 0px;\r\n            line-height: normal;\r\n        }\r\n        \r\n        .tagFilter_btn_cutting {\r\n            // Cutting operation tags - fixed width for consistency, wider than post-ops tags\r\n            display: inline-flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            padding: 10px 12px;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            border-radius: 10px;\r\n            text-transform: uppercase;\r\n            border: 0px;\r\n            line-height: normal;\r\n            color: #ffffff;\r\n            transition: all 0.2s ease;\r\n            cursor: pointer;\r\n            min-width: 70px;\r\n            width: 70px;\r\n            \r\n            &:hover {\r\n                filter: brightness(0.85);\r\n                transform: translateY(-1px);\r\n            }\r\n            \r\n            &.active {\r\n                filter: brightness(0.75);\r\n                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.SearchFilterfield{\r\n    position: relative;\r\n    .form-control{\r\n        padding-left: 42px!important;\r\n    }\r\n    .search_icon{\r\n        font-size: 18px;\r\n        left: 15px;\r\n        min-width: 18px;\r\n        opacity: .5;\r\n        position: absolute;\r\n        top: 15px;\r\n    }\r\n    .sortByFilterBtn {\r\n        position: absolute;\r\n        right: -15px;\r\n        top: 0px;\r\n        font-size: 18px;\r\n        color: $black-color;\r\n        display: inline-flex;\r\n        .sortFilterClose {\r\n            position: absolute;\r\n            font-size: 14px;\r\n            border: 1px solid #fff;\r\n            border-radius: 50%;\r\n            bottom: 0px;\r\n            right: -6px;\r\n        }\r\n    }\r\n  }\r\n  .datamain{\r\n    .btndata{\r\n        background: #d0e7ff;\r\n        color:#5b92cd;\r\n        font-size: 12px;\r\n        text-decoration: none;\r\n        text-transform: uppercase;\r\n        padding: 3px 6px;\r\n        border-radius: 30px;\r\n        display:inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        &:hover{\r\n            opacity: 0.75;\r\n        }\r\n    }\r\n}\r\n\r\n.postion_take {\r\n    font-size: 18px;\r\n    right: 8px;\r\n    min-width: 18px;\r\n    opacity: 0.5;\r\n    position: absolute;\r\n    top: 10px;\r\n}\r\n.btntrash {\r\n    width: 25px;\r\n    height: 25px;\r\n    background: $danger-color;\r\n    color: $white-color;\r\n    min-width: 25px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    font-size: 14px;\r\n}\r\n\r\n.statusactiveData {\r\n    font-size      : 12px;\r\n    border-radius  : 30px;\r\n    min-width      : 62px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n    color          : red!important;\r\n    background: rgba(rgb(255, 0, 0), 0.10);\r\n    padding: 0 9px;\r\n    height: 25px;\r\n    line-height: 25px;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.statusactiveNew {\r\n    font-size      : 12px;\r\n    border-radius  : 30px;\r\n    min-width      : 62px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n    background: rgba(1, 148, 60, 0.1);\r\n    color: #01943C;\r\n    padding: 0 9px;\r\n    height: 25px;\r\n    line-height: 25px;\r\n    text-transform: capitalize;\r\n}\r\n.refund-content{\r\n    p{\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        a{\r\n            text-decoration: underline;\r\n            color:$primary-color;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n.removefileimg{\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n.tracking-info.custom_rate{\r\n    p  {\r\n        .maxwidth130{\r\n            max-width: 130px;\r\n            display: inline-block;\r\n            width: 100%;\r\n        }\r\n    }\r\n}      \r\n.formtable{\r\n    &.table>:not(caption)>*>*{\r\n        border-bottom: none;\r\n        background-color:transparent;\r\n        \r\n    }\r\n   tr{\r\n    td{\r\n        input[type=\"checkbox\"]\r\n        {\r\n         width: 17px!important;\r\n         height: 17px!important;\r\n        }\r\n    }\r\n   }\r\n}\r\n.nopermission{\r\n    .card-body{\r\n        min-height: calc(100vh - 120px);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n    }\r\n    h1{\r\n        font-size: 40px;\r\n        margin: 12px 0;\r\n    }\r\n    p{\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.w-40{\r\n    width: 40%;\r\n    @media only screen and (max-width:1199.98px) {\r\n        width: initial;\r\n    }\r\n}\r\n.w-10{\r\n    width: 20%;\r\n    @media only screen and (max-width:1199.98px) {\r\n        width: initial;\r\n    }\r\n}\r\n.py-85rem{\r\n    padding-top:0.85rem!important;\r\n    padding-top:0.85rem!important\r\n}\r\n.fileuploadedgrid{\r\n    width: 100px;\r\n    height: 100px;\r\n    box-shadow: 0px 0px 10px rgba($black-color,0.06);\r\n    border-radius: 6px;\r\n    position:relative;\r\n    .btn-close {\r\n        width: 12px;\r\n        height: 12px;\r\n        opacity:1;\r\n        background-color: $danger-color;\r\n        --bs-btn-close-bg:url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e\");\r\n        border-radius: 50%;\r\n        background-size: 10px;\r\n        position:absolute;\r\n        top:10px;\r\n        right:10px;\r\n    }\r\n}\r\n.filegrid{\r\n    box-shadow: 0px 0px 10px rgba($black-color,0.06);\r\n    border-radius:30px;\r\n    display:inline-flex;\r\n    align-items:center;\r\n    justify-content:center;\r\n    padding: 10px 15px;\r\n    .btn-close {\r\n        width: 12px;\r\n        height: 12px;\r\n        opacity:1;\r\n        background-color: $danger-color;\r\n        --bs-btn-close-bg:url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e\");\r\n        border-radius: 50%;\r\n        background-size: 10px;\r\n    }\r\n}\r\n.quote_scroll_clss{\r\n    scrollbar-width: none;\r\n        height: auto !important;\r\n        overflow: visible!important;\r\n        > div{\r\n                height: auto !important;\r\n        }\r\n      .quote_lisiting_pge {\r\n    position: initial !important;\r\n    height: auto !important;\r\n}\r\n}","// ============================================\n// SHARED VARIABLES - Single Source of Truth\n// ============================================\n// Used by: Customer Portal, Admin Portal, Employee Portal\n//\n// DO NOT create duplicate variable files!\n// Import this file in all stylesheets:\n// @import \"../styles/variables\"\n// ============================================\n\n// ============================================\n// PRIMARY BRAND COLORS\n// ============================================\n// $primary-color:#4F8CCA; // Old blue (commented out)\n$primary-color: #3c5b8a;      // Main brand blue\n$secondary-color: #1F2E60;    // Dark navy\n$darkblue-color: #324b74;     // Medium blue\n\n// ============================================\n// STATUS & SEMANTIC COLORS\n// ============================================\n$danger-color: #E11F26;       // Red (errors, delete actions)\n$green-color: #2A5C17;        // Green (success states)\n$yellow-color: #FFBA16;       // Yellow (warnings)\n$yellow-color2: #ffda3f;      // Light yellow (highlights)\n$yellow-dark: #b38200;        // Dark yellow (text on yellow backgrounds)\n$purple-color: #7367F0;       // Purple (accent)\n\n// ============================================\n// POST OPS TAG COLORS\n// ============================================\n$pink-light: #ff8cd3;         // Pink (F-series tags)\n$pink-medium: #d65ba8;        // Dark pink (F-series text)\n$green-light: #4caf50;        // Green (B-series tags)\n$green-medium: #2e7d32;       // Dark green (B-series text)\n$red-light: #ef5350;          // Red (C-series tags)\n$red-medium: #c62828;         // Dark red (C-series text)\n$magenta-light: #d946ef;      // Magenta (Other-series tags)\n$magenta-medium: #a21caf;     // Dark magenta (Other-series text)\n\n// ============================================\n// NEUTRAL COLORS\n// ============================================\n$paragraph-color: #6C6A72;    // Body text gray\n$light-color: #bfbfbf;        // Light gray (borders, disabled states)\n$black-color: #000000;        // True black\n$dark-color: #212121;         // Dark gray (headings)\n$white-color: #ffffff;        // True white\n\n// ============================================\n// TYPOGRAPHY\n// ============================================\n$font-family: \"Inter\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
